var _regeneratorRuntime = require("/codebuild/output/src642477253/src/frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? t(exports, require("react"), require("uuid"), require("antd")) : "function" == typeof define && define.amd ? define(["exports", "react", "uuid", "antd"], t) : t((e = e || self).authenticatedApp = {}, e.React, e.uuid, e.antd);
}(this, function (e, t, n, r) {
  "use strict";

  var o = "default" in t ? t.default : t;

  function i(e, t, n, r, o, i, a) {
    try {
      var s = e[i](a),
          c = s.value;
    } catch (e) {
      return void n(e);
    }

    s.done ? t(c) : Promise.resolve(c).then(r, o);
  }

  function a(e) {
    return function () {
      var t = this,
          n = arguments;
      return new Promise(function (r, o) {
        var a = e.apply(t, n);

        function s(e) {
          i(a, r, o, s, c, "next", e);
        }

        function c(e) {
          i(a, r, o, s, c, "throw", e);
        }

        s(void 0);
      });
    };
  }

  function s(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
    }
  }

  function c(e, t, n) {
    return t in e ? Object.defineProperty(e, t, {
      value: n,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : e[t] = n, e;
  }

  function u() {
    return (u = Object.assign || function (e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = arguments[t];

        for (var r in n) {
          Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
      }

      return e;
    }).apply(this, arguments);
  }

  function l(e, t) {
    var n = Object.keys(e);

    if (Object.getOwnPropertySymbols) {
      var r = Object.getOwnPropertySymbols(e);
      t && (r = r.filter(function (t) {
        return Object.getOwnPropertyDescriptor(e, t).enumerable;
      })), n.push.apply(n, r);
    }

    return n;
  }

  function d(e) {
    for (var t = 1; t < arguments.length; t++) {
      var n = null != arguments[t] ? arguments[t] : {};
      t % 2 ? l(n, !0).forEach(function (t) {
        c(e, t, n[t]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : l(n).forEach(function (t) {
        Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
      });
    }

    return e;
  }

  function p(e) {
    return (p = Object.setPrototypeOf ? Object.getPrototypeOf : function (e) {
      return e.__proto__ || Object.getPrototypeOf(e);
    })(e);
  }

  function h(e, t) {
    return (h = Object.setPrototypeOf || function (e, t) {
      return e.__proto__ = t, e;
    })(e, t);
  }

  function f(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
  }

  function g(e, t) {
    return function (e) {
      if (Array.isArray(e)) return e;
    }(e) || function (e, t) {
      var n = [],
          r = !0,
          o = !1,
          i = void 0;

      try {
        for (var a, s = e[Symbol.iterator](); !(r = (a = s.next()).done) && (n.push(a.value), !t || n.length !== t); r = !0) {
          ;
        }
      } catch (e) {
        o = !0, i = e;
      } finally {
        try {
          r || null == s.return || s.return();
        } finally {
          if (o) throw i;
        }
      }

      return n;
    }(e, t) || function () {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }();
  }

  function m(e) {
    return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
  }

  function y(e, t) {
    return e(t = {
      exports: {}
    }, t.exports), t.exports;
  }

  var w = y(function (e, t) {
    Object.defineProperty(t, "__esModule", {
      value: !0
    });
    var n = "function" == typeof Symbol && Symbol.for,
        r = n ? Symbol.for("react.element") : 60103,
        o = n ? Symbol.for("react.portal") : 60106,
        i = n ? Symbol.for("react.fragment") : 60107,
        a = n ? Symbol.for("react.strict_mode") : 60108,
        s = n ? Symbol.for("react.profiler") : 60114,
        c = n ? Symbol.for("react.provider") : 60109,
        u = n ? Symbol.for("react.context") : 60110,
        l = n ? Symbol.for("react.async_mode") : 60111,
        d = n ? Symbol.for("react.concurrent_mode") : 60111,
        p = n ? Symbol.for("react.forward_ref") : 60112,
        h = n ? Symbol.for("react.suspense") : 60113,
        f = n ? Symbol.for("react.memo") : 60115,
        g = n ? Symbol.for("react.lazy") : 60116;

    function m(e) {
      if ("object" == typeof e && null !== e) {
        var t = e.$$typeof;

        switch (t) {
          case r:
            switch (e = e.type) {
              case l:
              case d:
              case i:
              case s:
              case a:
              case h:
                return e;

              default:
                switch (e = e && e.$$typeof) {
                  case u:
                  case p:
                  case c:
                    return e;

                  default:
                    return t;
                }

            }

          case g:
          case f:
          case o:
            return t;
        }
      }
    }

    function y(e) {
      return m(e) === d;
    }

    t.typeOf = m, t.AsyncMode = l, t.ConcurrentMode = d, t.ContextConsumer = u, t.ContextProvider = c, t.Element = r, t.ForwardRef = p, t.Fragment = i, t.Lazy = g, t.Memo = f, t.Portal = o, t.Profiler = s, t.StrictMode = a, t.Suspense = h, t.isValidElementType = function (e) {
      return "string" == typeof e || "function" == typeof e || e === i || e === d || e === s || e === a || e === h || "object" == typeof e && null !== e && (e.$$typeof === g || e.$$typeof === f || e.$$typeof === c || e.$$typeof === u || e.$$typeof === p);
    }, t.isAsyncMode = function (e) {
      return y(e) || m(e) === l;
    }, t.isConcurrentMode = y, t.isContextConsumer = function (e) {
      return m(e) === u;
    }, t.isContextProvider = function (e) {
      return m(e) === c;
    }, t.isElement = function (e) {
      return "object" == typeof e && null !== e && e.$$typeof === r;
    }, t.isForwardRef = function (e) {
      return m(e) === p;
    }, t.isFragment = function (e) {
      return m(e) === i;
    }, t.isLazy = function (e) {
      return m(e) === g;
    }, t.isMemo = function (e) {
      return m(e) === f;
    }, t.isPortal = function (e) {
      return m(e) === o;
    }, t.isProfiler = function (e) {
      return m(e) === s;
    }, t.isStrictMode = function (e) {
      return m(e) === a;
    }, t.isSuspense = function (e) {
      return m(e) === h;
    };
  });
  m(w);
  w.typeOf, w.AsyncMode, w.ConcurrentMode, w.ContextConsumer, w.ContextProvider, w.Element, w.ForwardRef, w.Fragment, w.Lazy, w.Memo, w.Portal, w.Profiler, w.StrictMode, w.Suspense, w.isValidElementType, w.isAsyncMode, w.isConcurrentMode, w.isContextConsumer, w.isContextProvider, w.isElement, w.isForwardRef, w.isFragment, w.isLazy, w.isMemo, w.isPortal, w.isProfiler, w.isStrictMode, w.isSuspense;
  var v = y(function (e, t) {});
  m(v);
  v.typeOf, v.AsyncMode, v.ConcurrentMode, v.ContextConsumer, v.ContextProvider, v.Element, v.ForwardRef, v.Fragment, v.Lazy, v.Memo, v.Portal, v.Profiler, v.StrictMode, v.Suspense, v.isValidElementType, v.isAsyncMode, v.isConcurrentMode, v.isContextConsumer, v.isContextProvider, v.isElement, v.isForwardRef, v.isFragment, v.isLazy, v.isMemo, v.isPortal, v.isProfiler, v.isStrictMode, v.isSuspense, y(function (e) {
    e.exports = w;
  });
  var b = Object.getOwnPropertySymbols,
      k = Object.prototype.hasOwnProperty,
      I = Object.prototype.propertyIsEnumerable;

  function S(e) {
    if (null == e) throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(e);
  }

  (function () {
    try {
      if (!Object.assign) return !1;
      var e = new String("abc");
      if (e[5] = "de", "5" === Object.getOwnPropertyNames(e)[0]) return !1;

      for (var t = {}, n = 0; n < 10; n++) {
        t["_" + String.fromCharCode(n)] = n;
      }

      if ("0123456789" !== Object.getOwnPropertyNames(t).map(function (e) {
        return t[e];
      }).join("")) return !1;
      var r = {};
      return "abcdefghijklmnopqrst".split("").forEach(function (e) {
        r[e] = e;
      }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, r)).join("");
    } catch (e) {
      return !1;
    }
  })() && Object.assign;
  var T = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  Function.call.bind(Object.prototype.hasOwnProperty);

  function C() {}

  function E() {}

  E.resetWarningCache = C;

  var P = y(function (e) {
    e.exports = function () {
      function e(e, t, n, r, o, i) {
        if (i !== T) {
          var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
          throw a.name = "Invariant Violation", a;
        }
      }

      function t() {
        return e;
      }

      e.isRequired = e;
      var n = {
        array: e,
        bool: e,
        func: e,
        number: e,
        object: e,
        string: e,
        symbol: e,
        any: e,
        arrayOf: t,
        element: e,
        elementType: e,
        instanceOf: t,
        node: e,
        objectOf: t,
        oneOf: t,
        oneOfType: t,
        shape: t,
        exact: t,
        checkPropTypes: E,
        resetWarningCache: C
      };
      return n.PropTypes = n, n;
    }();
  }),
      _A = function A(e, t) {
    return (_A = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, t) {
      e.__proto__ = t;
    } || function (e, t) {
      for (var n in t) {
        t.hasOwnProperty(n) && (e[n] = t[n]);
      }
    })(e, t);
  };

  function O(e, t) {
    function n() {
      this.constructor = e;
    }

    _A(e, t), e.prototype = null === t ? Object.create(t) : (n.prototype = t.prototype, new n());
  }

  var _R = function R() {
    return (_R = Object.assign || function (e) {
      for (var t, n = 1, r = arguments.length; n < r; n++) {
        for (var o in t = arguments[n]) {
          Object.prototype.hasOwnProperty.call(t, o) && (e[o] = t[o]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  var x,
      _ = function () {
    function e() {}

    return Object.defineProperty(e, "errorDescription", {
      get: function get() {
        return "error_description";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "error", {
      get: function get() {
        return "error";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "scope", {
      get: function get() {
        return "scope";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "clientInfo", {
      get: function get() {
        return "client_info";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "clientId", {
      get: function get() {
        return "clientId";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "idToken", {
      get: function get() {
        return "id_token";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "adalIdToken", {
      get: function get() {
        return "adal.idtoken";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "accessToken", {
      get: function get() {
        return "access_token";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "expiresIn", {
      get: function get() {
        return "expires_in";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "sessionState", {
      get: function get() {
        return "session_state";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "claims", {
      get: function get() {
        return "claims";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "msalClientInfo", {
      get: function get() {
        return "msal.client.info";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "msalError", {
      get: function get() {
        return "msal.error";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "msalErrorDescription", {
      get: function get() {
        return "msal.error.description";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "msalSessionState", {
      get: function get() {
        return "msal.session.state";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "tokenKeys", {
      get: function get() {
        return "msal.token.keys";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "accessTokenKey", {
      get: function get() {
        return "msal.access.token.key";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "expirationKey", {
      get: function get() {
        return "msal.expiration.key";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "stateLogin", {
      get: function get() {
        return "msal.state.login";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "stateAcquireToken", {
      get: function get() {
        return "msal.state.acquireToken";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "stateRenew", {
      get: function get() {
        return "msal.state.renew";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "nonceIdToken", {
      get: function get() {
        return "msal.nonce.idtoken";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "userName", {
      get: function get() {
        return "msal.username";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "idTokenKey", {
      get: function get() {
        return "msal.idtoken";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "loginRequest", {
      get: function get() {
        return "msal.login.request";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "loginError", {
      get: function get() {
        return "msal.login.error";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "renewStatus", {
      get: function get() {
        return "msal.token.renew.status";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "urlHash", {
      get: function get() {
        return "msal.urlHash";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "angularLoginRequest", {
      get: function get() {
        return "msal.angular.login.request";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "msal", {
      get: function get() {
        return "msal";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "no_account", {
      get: function get() {
        return "NO_ACCOUNT";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "consumersUtid", {
      get: function get() {
        return "9188040d-6c67-4c5b-b112-36a304b66dad";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "upn", {
      get: function get() {
        return "upn";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "prompt_select_account", {
      get: function get() {
        return "&prompt=select_account";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "prompt_none", {
      get: function get() {
        return "&prompt=none";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "prompt", {
      get: function get() {
        return "prompt";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "response_mode_fragment", {
      get: function get() {
        return "&response_mode=fragment";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "resourceDelimiter", {
      get: function get() {
        return "|";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "tokenRenewStatusCancelled", {
      get: function get() {
        return "Canceled";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "tokenRenewStatusCompleted", {
      get: function get() {
        return "Completed";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "tokenRenewStatusInProgress", {
      get: function get() {
        return "In Progress";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "popUpWidth", {
      get: function get() {
        return this._popUpWidth;
      },
      set: function set(e) {
        this._popUpWidth = e;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "popUpHeight", {
      get: function get() {
        return this._popUpHeight;
      },
      set: function set(e) {
        this._popUpHeight = e;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "login", {
      get: function get() {
        return "LOGIN";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "renewToken", {
      get: function get() {
        return "RENEW_TOKEN";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "unknown", {
      get: function get() {
        return "UNKNOWN";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "homeAccountIdentifier", {
      get: function get() {
        return "homeAccountIdentifier";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "common", {
      get: function get() {
        return "common";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "openidScope", {
      get: function get() {
        return "openid";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "profileScope", {
      get: function get() {
        return "profile";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "cacheLocationLocal", {
      get: function get() {
        return "localStorage";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "cacheLocationSession", {
      get: function get() {
        return "sessionStorage";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "interactionTypeRedirect", {
      get: function get() {
        return "redirectInteraction";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e, "interactionTypePopup", {
      get: function get() {
        return "popupInteraction";
      },
      enumerable: !0,
      configurable: !0
    }), e._popUpWidth = 483, e._popUpHeight = 600, e;
  }(),
      q = "msal.authority",
      j = "msal.acquireTokenAccount",
      U = {
    "login.windows.net": "login.windows.net",
    "login.chinacloudapi.cn": "login.chinacloudapi.cn",
    "login.cloudgovapi.us": "login.cloudgovapi.us",
    "login.microsoftonline.com": "login.microsoftonline.com",
    "login.microsoftonline.de": "login.microsoftonline.de",
    "login.microsoftonline.us": "login.microsoftonline.us"
  },
      L = "sid",
      M = "login_hint",
      N = "id_token",
      D = "domain_hint",
      H = "organizations",
      F = "consumers",
      W = "homeAccountIdentifier",
      V = "login_req",
      K = "domain_req",
      z = [L, M],
      G = {
    LOGIN: "login",
    SELECT_ACCOUNT: "select_account",
    CONSENT: "consent",
    NONE: "none"
  },
      B = "1.1.1",
      J = function () {
    function e() {}

    return e.compareAccounts = function (e, t) {
      return !(!e || !t) && !(!e.homeAccountIdentifier || !t.homeAccountIdentifier || e.homeAccountIdentifier !== t.homeAccountIdentifier);
    }, e.decimalToHex = function (e) {
      for (var t = e.toString(16); t.length < 2;) {
        t = "0" + t;
      }

      return t;
    }, e.getLibraryVersion = function () {
      return B;
    }, e.createNewGuid = function () {
      var t = window.crypto;

      if (t && t.getRandomValues) {
        var n = new Uint8Array(16);
        return t.getRandomValues(n), n[6] |= 64, n[6] &= 79, n[8] |= 128, n[8] &= 191, e.decimalToHex(n[0]) + e.decimalToHex(n[1]) + e.decimalToHex(n[2]) + e.decimalToHex(n[3]) + "-" + e.decimalToHex(n[4]) + e.decimalToHex(n[5]) + "-" + e.decimalToHex(n[6]) + e.decimalToHex(n[7]) + "-" + e.decimalToHex(n[8]) + e.decimalToHex(n[9]) + "-" + e.decimalToHex(n[10]) + e.decimalToHex(n[11]) + e.decimalToHex(n[12]) + e.decimalToHex(n[13]) + e.decimalToHex(n[14]) + e.decimalToHex(n[15]);
      }

      for (var r = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx", o = "0123456789abcdef", i = 0, a = "", s = 0; s < 36; s++) {
        "-" !== r[s] && "4" !== r[s] && (i = 16 * Math.random() | 0), "x" === r[s] ? a += o[i] : "y" === r[s] ? (i &= 3, a += o[i |= 8]) : a += r[s];
      }

      return a;
    }, e.parseExpiresIn = function (e) {
      return e || (e = "3599"), parseInt(e, 10);
    }, e.now = function () {
      return Math.round(new Date().getTime() / 1e3);
    }, e.isEmpty = function (e) {
      return void 0 === e || !e || 0 === e.length;
    }, e.decodeJwt = function (e) {
      if (this.isEmpty(e)) return null;
      var t = /^([^\.\s]*)\.([^\.\s]+)\.([^\.\s]*)$/.exec(e);
      return !t || t.length < 4 ? null : {
        header: t[1],
        JWSPayload: t[2],
        JWSSig: t[3]
      };
    }, e.extractIdToken = function (e) {
      var t = this.decodeJwt(e);
      if (!t) return null;

      try {
        var n = t.JWSPayload,
            r = this.base64Decode(n);
        return r ? JSON.parse(r) : null;
      } catch (e) {}

      return null;
    }, e.base64Encode = function (e) {
      return btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g, function (e, t) {
        return String.fromCharCode(Number("0x" + t));
      }));
    }, e.base64Decode = function (e) {
      return decodeURIComponent(atob(e).split("").map(function (e) {
        return "%" + ("00" + e.charCodeAt(0).toString(16)).slice(-2);
      }).join(""));
    }, e.deserialize = function (e) {
      var t,
          n = /\+/g,
          r = /([^&=]+)=([^&]*)/g,
          o = function o(e) {
        return decodeURIComponent(e.replace(n, " "));
      },
          i = {};

      for (t = r.exec(e); t;) {
        i[o(t[1])] = o(t[2]), t = r.exec(e);
      }

      return i;
    }, e.isIntersectingScopes = function (e, t) {
      e = this.convertToLowerCase(e);

      for (var n = 0; n < t.length; n++) {
        if (e.indexOf(t[n].toLowerCase()) > -1) return !0;
      }

      return !1;
    }, e.containsScope = function (e, t) {
      return e = this.convertToLowerCase(e), t.every(function (t) {
        return e.indexOf(t.toString().toLowerCase()) >= 0;
      });
    }, e.convertToLowerCase = function (e) {
      return e.map(function (e) {
        return e.toLowerCase();
      });
    }, e.removeElement = function (e, t) {
      return e.filter(function (e) {
        return e !== t;
      });
    }, e.getDefaultRedirectUri = function () {
      return window.location.href.split("?")[0].split("#")[0];
    }, e.replaceTenantPath = function (e, t) {
      e = e.toLowerCase();
      var n = this.GetUrlComponents(e),
          r = n.PathSegments;
      return !t || 0 === r.length || r[0] !== _.common && r[0] !== H || (r[0] = t), this.constructAuthorityUriFromObject(n, r);
    }, e.constructAuthorityUriFromObject = function (e, t) {
      return this.CanonicalizeUri(e.Protocol + "//" + e.HostNameAndPort + "/" + t.join("/"));
    }, e.GetUrlComponents = function (e) {
      if (!e) throw "Url required";
      var t = RegExp("^(([^:/?#]+):)?(//([^/?#]*))?([^?#]*)(\\?([^#]*))?(#(.*))?"),
          n = e.match(t);
      if (!n || n.length < 6) throw "Valid url required";
      var r = {
        Protocol: n[1],
        HostNameAndPort: n[4],
        AbsolutePath: n[5]
      },
          o = r.AbsolutePath.split("/");
      return o = o.filter(function (e) {
        return e && e.length > 0;
      }), r.PathSegments = o, r;
    }, e.CanonicalizeUri = function (t) {
      return t && (t = t.toLowerCase()), t && !e.endsWith(t, "/") && (t += "/"), t;
    }, e.endsWith = function (e, t) {
      return !(!e || !t) && -1 !== e.indexOf(t, e.length - t.length);
    }, e.urlRemoveQueryStringParameter = function (e, t) {
      if (this.isEmpty(e)) return e;
      var n = new RegExp("(\\&" + t + "=)[^&]+");
      return e = e.replace(n, ""), n = new RegExp("(" + t + "=)[^&]+&"), e = e.replace(n, ""), n = new RegExp("(" + t + "=)[^&]+"), e = e.replace(n, "");
    }, e.getHashFromUrl = function (e) {
      var t = e.indexOf("#"),
          n = e.indexOf("#/");
      return n > -1 ? e.substring(n + 2) : t > -1 ? e.substring(t + 1) : e;
    }, e.constructUnifiedCacheQueryParameter = function (e, t) {
      var n,
          r,
          o = {};
      if (e) {
        if (e.account) {
          var i = e.account;
          i.sid ? (n = L, r = i.sid) : i.userName && (n = M, r = i.userName);
        } else e.sid ? (n = L, r = e.sid) : e.loginHint && (n = M, r = e.loginHint);
      } else t && (t.hasOwnProperty(_.upn) ? (n = N, r = t.upn) : (n = H, r = null));
      return o = this.addSSOParameter(n, r), e && e.account && e.account.homeAccountIdentifier && (o = this.addSSOParameter(W, e.account.homeAccountIdentifier, o)), o;
    }, e.addSSOParameter = function (t, n, r) {
      if (r || (r = {}), !n) return r;

      switch (t) {
        case L:
          r[L] = n;
          break;

        case N:
          r[M] = n, r[D] = H;
          break;

        case M:
          r[M] = n;
          break;

        case H:
          r[D] = H;
          break;

        case F:
          r[D] = F;
          break;

        case W:
          var o = n.split("."),
              i = e.base64Decode(o[0]),
              a = e.base64Decode(o[1]);
          r[V] = i, r[K] = a, a === _.consumersUtid ? r[D] = F : r[D] = H;
          break;

        case V:
          r[V] = n;
          break;

        case K:
          r[K] = n;
      }

      return r;
    }, e.generateQueryParametersString = function (e) {
      var t = null;
      return e && Object.keys(e).forEach(function (n) {
        null == t ? t = n + "=" + encodeURIComponent(e[n]) : t += "&" + n + "=" + encodeURIComponent(e[n]);
      }), t;
    }, e.isSSOParam = function (e) {
      return e && (e.account || e.sid || e.loginHint);
    }, e.setResponseIdToken = function (e, t) {
      var n = Number(t.expiration);
      return n && !e.expiresOn && (e.expiresOn = new Date(1e3 * n)), _R({}, e, {
        idToken: t,
        idTokenClaims: t.claims,
        uniqueId: t.objectId || t.subject,
        tenantId: t.tenantId
      });
    }, e;
  }(),
      Q = function Q(e, t, n, r, o) {
    this.authority = J.CanonicalizeUri(e), this.clientId = t, this.scopes = n, this.homeAccountIdentifier = J.base64Encode(r) + "." + J.base64Encode(o);
  },
      $ = function $(e, t, n, r) {
    this.accessToken = e, this.idToken = t, this.expiresIn = n, this.homeAccountIdentifier = r;
  },
      Y = function () {
    function e(e, t, n, r, o, i) {
      this.authorityInstance = e, this.clientId = t, this.scopes = n, this.nonce = J.createNewGuid(), this.state = i && !J.isEmpty(i) ? J.createNewGuid() + "|" + i : J.createNewGuid(), this.correlationId = J.createNewGuid(), this.xClientSku = "MSAL.JS", this.xClientVer = J.getLibraryVersion(), this.responseType = r, this.redirectUri = o;
    }

    return Object.defineProperty(e.prototype, "authority", {
      get: function get() {
        return this.authorityInstance ? this.authorityInstance.CanonicalAuthority : null;
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.createNavigateUrl = function (e) {
      var t = this.createNavigationUrlString(e),
          n = this.authorityInstance.AuthorizationEndpoint;
      return n.indexOf("?") < 0 ? n += "?" : n += "&", "" + n + t.join("&");
    }, e.prototype.createNavigationUrlString = function (e) {
      e || (e = [this.clientId]), -1 === e.indexOf(this.clientId) && e.push(this.clientId);
      var t = [];
      return t.push("response_type=" + this.responseType), this.translateclientIdUsedInScope(e), t.push("scope=" + encodeURIComponent(this.parseScope(e))), t.push("client_id=" + encodeURIComponent(this.clientId)), t.push("redirect_uri=" + encodeURIComponent(this.redirectUri)), t.push("state=" + encodeURIComponent(this.state)), t.push("nonce=" + encodeURIComponent(this.nonce)), t.push("client_info=1"), t.push("x-client-SKU=" + this.xClientSku), t.push("x-client-Ver=" + this.xClientVer), this.promptValue && t.push("prompt=" + encodeURIComponent(this.promptValue)), this.claimsValue && t.push("claims=" + encodeURIComponent(this.claimsValue)), this.queryParameters && t.push(this.queryParameters), this.extraQueryParameters && t.push(this.extraQueryParameters), t.push("client-request-id=" + encodeURIComponent(this.correlationId)), t;
    }, e.prototype.translateclientIdUsedInScope = function (e) {
      var t = e.indexOf(this.clientId);
      t >= 0 && (e.splice(t, 1), -1 === e.indexOf("openid") && e.push("openid"), -1 === e.indexOf("profile") && e.push("profile"));
    }, e.prototype.parseScope = function (e) {
      var t = "";
      if (e) for (var n = 0; n < e.length; ++n) {
        t += n !== e.length - 1 ? e[n] + " " : e[n];
      }
      return t;
    }, e;
  }(),
      X = {
    code: "unexpected_error",
    desc: "Unexpected error in authentication."
  },
      Z = function (e) {
    function t(n, r) {
      var o = e.call(this, r) || this;
      return Object.setPrototypeOf(o, t.prototype), o.errorCode = n, o.errorMessage = r, o.name = "AuthError", o;
    }

    return O(t, e), t.createUnexpectedError = function (e) {
      return new t(X.code, X.desc + ": " + e);
    }, t;
  }(Error),
      ee = {
    code: "multiple_matching_tokens",
    desc: "The cache contains multiple tokens satisfying the requirements. Call AcquireToken again providing more requirements like authority."
  },
      te = {
    code: "multiple_authorities",
    desc: "Multiple authorities found in the cache. Pass authority in the API overload."
  },
      ne = {
    code: "endpoints_resolution_error",
    desc: "Error: could not resolve endpoints. Please check network and try again."
  },
      re = {
    code: "popup_window_error",
    desc: "Error opening popup window. This can happen if you are using IE or if popups are blocked in the browser."
  },
      oe = {
    code: "token_renewal_error",
    desc: "Token renewal operation failed due to timeout."
  },
      ie = {
    code: "invalid_id_token",
    desc: "Invalid ID token format."
  },
      ae = {
    code: "invalid_state_error",
    desc: "Invalid state."
  },
      se = {
    code: "nonce_mismatch_error",
    desc: "Nonce is not matching, Nonce received: "
  },
      ce = {
    code: "login_progress_error",
    desc: "Login_In_Progress: Error during login call - login is already in progress."
  },
      ue = {
    code: "acquiretoken_progress_error",
    desc: "AcquireToken_In_Progress: Error during login call - login is already in progress."
  },
      le = {
    code: "user_cancelled",
    desc: "User cancelled the flow."
  },
      de = {
    code: "callback_error",
    desc: "Error occurred in token received callback function."
  },
      pe = {
    code: "user_login_error",
    desc: "User login is required."
  },
      he = {
    code: "user_non_existent",
    desc: "User object does not exist. Please call a login API."
  },
      fe = {
    code: "client_info_decoding_error",
    desc: "The client info could not be parsed/decoded correctly. Please review the trace to determine the root cause."
  },
      ge = {
    code: "client_info_not_populated_error",
    desc: "The service did not populate client_info in the response, Please verify with the service team"
  },
      me = {
    code: "null_or_empty_id_token",
    desc: "The idToken is null or empty. Please review the trace to determine the root cause."
  },
      ye = {
    code: "id_token_parsing_error",
    desc: "ID token cannot be parsed. Please review stack trace to determine root cause."
  },
      we = {
    code: "token_encoding_error",
    desc: "The token to be decoded is not encoded correctly."
  },
      ve = {
    code: "invalid_interaction_type",
    desc: "The interaction type passed to the handler was incorrect or unknown"
  },
      be = function (e) {
    function t(n, r) {
      var o = e.call(this, n, r) || this;
      return o.name = "ClientAuthError", Object.setPrototypeOf(o, t.prototype), o;
    }

    return O(t, e), t.createEndpointResolutionError = function (e) {
      var n = ne.desc;
      return e && !J.isEmpty(e) && (n += " Details: " + e), new t(ne.code, n);
    }, t.createMultipleMatchingTokensInCacheError = function (e) {
      return new t(ee.code, "Cache error for scope " + e + ": " + ee.desc + ".");
    }, t.createMultipleAuthoritiesInCacheError = function (e) {
      return new t(te.code, "Cache error for scope " + e + ": " + te.desc + ".");
    }, t.createPopupWindowError = function (e) {
      var n = re.desc;
      return e && !J.isEmpty(e) && (n += " Details: " + e), new t(re.code, n);
    }, t.createTokenRenewalTimeoutError = function () {
      return new t(oe.code, oe.desc);
    }, t.createInvalidIdTokenError = function (e) {
      return new t(ie.code, ie.desc + " Given token: " + e);
    }, t.createInvalidStateError = function (e, n) {
      return new t(ae.code, ae.desc + " " + e + ", state expected : " + n + ".");
    }, t.createNonceMismatchError = function (e, n) {
      return new t(se.code, se.desc + " " + e + ", nonce expected : " + n + ".");
    }, t.createLoginInProgressError = function () {
      return new t(ce.code, ce.desc);
    }, t.createAcquireTokenInProgressError = function () {
      return new t(ue.code, ue.desc);
    }, t.createUserCancelledError = function () {
      return new t(le.code, le.desc);
    }, t.createErrorInCallbackFunction = function (e) {
      return new t(de.code, de.desc + " " + e + ".");
    }, t.createUserLoginRequiredError = function () {
      return new t(pe.code, pe.desc);
    }, t.createUserDoesNotExistError = function () {
      return new t(he.code, he.desc);
    }, t.createClientInfoDecodingError = function (e) {
      return new t(fe.code, fe.desc + " Failed with error: " + e);
    }, t.createClientInfoNotPopulatedError = function (e) {
      return new t(ge.code, ge.desc + " Failed with error: " + e);
    }, t.createIdTokenNullOrEmptyError = function (e) {
      return new t(me.code, me.desc + " Raw ID Token Value: " + e);
    }, t.createIdTokenParsingError = function (e) {
      return new t(ye.code, ye.desc + " Failed with error: " + e);
    }, t.createTokenEncodingError = function (e) {
      return new t(we.code, we.desc + " Attempted to decode: " + e);
    }, t.createInvalidInteractionTypeError = function () {
      return new t(ve.code, ve.desc);
    }, t;
  }(Z),
      ke = function () {
    function e(e) {
      if (!e || J.isEmpty(e)) return this.uid = "", void (this.utid = "");

      try {
        var t = J.base64Decode(e),
            n = JSON.parse(t);
        n && (n.hasOwnProperty("uid") && (this.uid = n.uid), n.hasOwnProperty("utid") && (this.utid = n.utid));
      } catch (e) {
        throw be.createClientInfoDecodingError(e);
      }
    }

    return Object.defineProperty(e.prototype, "uid", {
      get: function get() {
        return this._uid ? this._uid : "";
      },
      set: function set(e) {
        this._uid = e;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "utid", {
      get: function get() {
        return this._utid ? this._utid : "";
      },
      set: function set(e) {
        this._utid = e;
      },
      enumerable: !0,
      configurable: !0
    }), e;
  }(),
      Ie = function Ie(e) {
    if (J.isEmpty(e)) throw be.createIdTokenNullOrEmptyError(e);

    try {
      this.rawIdToken = e, this.claims = J.extractIdToken(e), this.claims && (this.claims.hasOwnProperty("iss") && (this.issuer = this.claims.iss), this.claims.hasOwnProperty("oid") && (this.objectId = this.claims.oid), this.claims.hasOwnProperty("sub") && (this.subject = this.claims.sub), this.claims.hasOwnProperty("tid") && (this.tenantId = this.claims.tid), this.claims.hasOwnProperty("ver") && (this.version = this.claims.ver), this.claims.hasOwnProperty("preferred_username") && (this.preferredName = this.claims.preferred_username), this.claims.hasOwnProperty("name") && (this.name = this.claims.name), this.claims.hasOwnProperty("nonce") && (this.nonce = this.claims.nonce), this.claims.hasOwnProperty("exp") && (this.expiration = this.claims.exp), this.claims.hasOwnProperty("home_oid") && (this.homeObjectId = this.claims.home_oid), this.claims.hasOwnProperty("sid") && (this.sid = this.claims.sid));
    } catch (e) {
      throw be.createIdTokenParsingError(e);
    }
  },
      Se = function Se(e, t) {
    this.key = e, this.value = t;
  },
      Te = {
    configurationNotSet: {
      code: "no_config_set",
      desc: "Configuration has not been set. Please call the UserAgentApplication constructor with a valid Configuration object."
    },
    invalidCacheLocation: {
      code: "invalid_cache_location",
      desc: "The cache location provided is not valid."
    },
    noStorageSupported: {
      code: "browser_storage_not_supported",
      desc: "localStorage and sessionStorage are not supported."
    },
    noRedirectCallbacksSet: {
      code: "no_redirect_callbacks",
      desc: "No redirect callbacks have been set. Please call setRedirectCallbacks() with the appropriate function arguments before continuing. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    invalidCallbackObject: {
      code: "invalid_callback_object",
      desc: "The object passed for the callback was invalid. More information is available here: https://github.com/AzureAD/microsoft-authentication-library-for-js/wiki/MSAL-basics."
    },
    scopesRequired: {
      code: "scopes_required",
      desc: "Scopes are required to obtain an access token."
    },
    emptyScopes: {
      code: "empty_input_scopes_error",
      desc: "Scopes cannot be passed as empty array."
    },
    nonArrayScopes: {
      code: "nonarray_input_scopes_error",
      desc: "Scopes cannot be passed as non-array."
    },
    clientScope: {
      code: "clientid_input_scopes_error",
      desc: "Client ID can only be provided as a single scope."
    },
    invalidPrompt: {
      code: "invalid_prompt_value",
      desc: "Supported prompt values are 'login', 'select_account', 'consent' and 'none'"
    },
    invalidAuthorityType: {
      code: "invalid_authority_type",
      desc: "The given authority is not a valid type of authority supported by MSAL. Please see here for valid authorities: <insert URL here>."
    },
    authorityUriInsecure: {
      code: "authority_uri_insecure",
      desc: "Authority URIs must use https."
    },
    authorityUriInvalidPath: {
      code: "authority_uri_invalid_path",
      desc: "Given authority URI is invalid."
    },
    unsupportedAuthorityValidation: {
      code: "unsupported_authority_validation",
      desc: "The authority validation is not supported for this authority type."
    },
    b2cAuthorityUriInvalidPath: {
      code: "b2c_authority_uri_invalid_path",
      desc: "The given URI for the B2C authority is invalid."
    },
    claimsRequestParsingError: {
      code: "claims_request_parsing_error",
      desc: "Could not parse the given claims request object."
    },
    emptyRequestError: {
      code: "empty_request_error",
      desc: "Request object is required."
    },
    telemetryConfigError: {
      code: "telemetry_config_error",
      desc: "Telemetry config is not configured with required values"
    }
  },
      Ce = function (e) {
    function t(n, r) {
      var o = e.call(this, n, r) || this;
      return o.name = "ClientConfigurationError", Object.setPrototypeOf(o, t.prototype), o;
    }

    return O(t, e), t.createNoSetConfigurationError = function () {
      return new t(Te.configurationNotSet.code, "" + Te.configurationNotSet.desc);
    }, t.createInvalidCacheLocationConfigError = function (e) {
      return new t(Te.invalidCacheLocation.code, Te.invalidCacheLocation.desc + " Provided value: " + e + ". Possible values are: " + _.cacheLocationLocal + ", " + _.cacheLocationSession + ".");
    }, t.createNoStorageSupportedError = function () {
      return new t(Te.noStorageSupported.code, Te.noStorageSupported.desc);
    }, t.createRedirectCallbacksNotSetError = function () {
      return new t(Te.noRedirectCallbacksSet.code, Te.noRedirectCallbacksSet.desc);
    }, t.createInvalidCallbackObjectError = function (e) {
      return new t(Te.invalidCallbackObject.code, Te.invalidCallbackObject.desc + " Given value for callback function: " + e);
    }, t.createEmptyScopesArrayError = function (e) {
      return new t(Te.emptyScopes.code, Te.emptyScopes.desc + " Given value: " + e + ".");
    }, t.createScopesNonArrayError = function (e) {
      return new t(Te.nonArrayScopes.code, Te.nonArrayScopes.desc + " Given value: " + e + ".");
    }, t.createClientIdSingleScopeError = function (e) {
      return new t(Te.clientScope.code, Te.clientScope.desc + " Given value: " + e + ".");
    }, t.createScopesRequiredError = function (e) {
      return new t(Te.scopesRequired.code, Te.scopesRequired.desc + " Given value: " + e);
    }, t.createInvalidPromptError = function (e) {
      return new t(Te.invalidPrompt.code, Te.invalidPrompt.desc + " Given value: " + e);
    }, t.createClaimsRequestParsingError = function (e) {
      return new t(Te.claimsRequestParsingError.code, Te.claimsRequestParsingError.desc + " Given value: " + e);
    }, t.createEmptyRequestError = function () {
      var e = Te.emptyRequestError;
      return new t(e.code, e.desc);
    }, t.createTelemetryConfigError = function (e) {
      var n = Te.telemetryConfigError,
          r = n.code,
          o = n.desc,
          i = {
        applicationName: "string",
        applicationVersion: "string",
        telemetryEmitter: "function"
      };
      return new t(r, o + " mising values: " + Object.keys(i).reduce(function (t, n) {
        return e[n] ? t : t.concat([n + " (" + i[n] + ")"]);
      }, []).join(","));
    }, t;
  }(be),
      Ee = function () {
    function e(t) {
      if (e.instance) return e.instance;
      if (this.cacheLocation = t, this.localStorageSupported = void 0 !== window[this.cacheLocation] && null != window[this.cacheLocation], this.sessionStorageSupported = void 0 !== window[t] && null != window[t], e.instance = this, !this.localStorageSupported && !this.sessionStorageSupported) throw Ce.createNoStorageSupportedError();
      return e.instance;
    }

    return e.prototype.setItem = function (e, t, n) {
      window[this.cacheLocation] && window[this.cacheLocation].setItem(e, t), n && this.setItemCookie(e, t);
    }, e.prototype.getItem = function (e, t) {
      return t && this.getItemCookie(e) ? this.getItemCookie(e) : window[this.cacheLocation] ? window[this.cacheLocation].getItem(e) : null;
    }, e.prototype.removeItem = function (e) {
      if (window[this.cacheLocation]) return window[this.cacheLocation].removeItem(e);
    }, e.prototype.clear = function () {
      if (window[this.cacheLocation]) return window[this.cacheLocation].clear();
    }, e.prototype.getAllAccessTokens = function (e, t) {
      var n,
          r = [],
          o = window[this.cacheLocation];

      if (o) {
        var i = void 0;

        for (i in o) {
          if (o.hasOwnProperty(i) && i.match(e) && i.match(t)) {
            var a = this.getItem(i);
            a && (n = new Se(JSON.parse(i), JSON.parse(a)), r.push(n));
          }
        }
      }

      return r;
    }, e.prototype.removeAcquireTokenEntries = function (e) {
      var t = window[this.cacheLocation];

      if (t) {
        var n = void 0;

        for (n in t) {
          if (t.hasOwnProperty(n) && !(-1 === n.indexOf(q) && 1 === n.indexOf(j) || e && -1 === n.indexOf(e))) {
            var r = n.split(_.resourceDelimiter),
                o = void 0;
            r.length > 1 && (o = r[1]), o && !this.tokenRenewalInProgress(o) && (this.removeItem(n), this.removeItem(_.renewStatus + o), this.removeItem(_.stateLogin), this.removeItem(_.stateAcquireToken), this.setItemCookie(n, "", -1));
          }
        }
      }

      this.clearCookie();
    }, e.prototype.tokenRenewalInProgress = function (e) {
      var t = window[this.cacheLocation][_.renewStatus + e];
      return !(!t || t !== _.tokenRenewStatusInProgress);
    }, e.prototype.resetCacheItems = function () {
      var e = window[this.cacheLocation];

      if (e) {
        var t = void 0;

        for (t in e) {
          e.hasOwnProperty(t) && -1 !== t.indexOf(_.msal) && this.removeItem(t);
        }

        this.removeAcquireTokenEntries();
      }
    }, e.prototype.setItemCookie = function (e, t, n) {
      var r = e + "=" + t + ";";
      n && (r += "expires=" + this.getCookieExpirationTime(n) + ";");
      document.cookie = r;
    }, e.prototype.getItemCookie = function (e) {
      for (var t = e + "=", n = document.cookie.split(";"), r = 0; r < n.length; r++) {
        for (var o = n[r]; " " === o.charAt(0);) {
          o = o.substring(1);
        }

        if (0 === o.indexOf(t)) return o.substring(t.length, o.length);
      }

      return "";
    }, e.prototype.getCookieExpirationTime = function (e) {
      var t = new Date();
      return new Date(t.getTime() + 24 * e * 60 * 60 * 1e3).toUTCString();
    }, e.prototype.clearCookie = function () {
      this.setItemCookie(_.nonceIdToken, "", -1), this.setItemCookie(_.stateLogin, "", -1), this.setItemCookie(_.loginRequest, "", -1), this.setItemCookie(_.stateAcquireToken, "", -1);
    }, e.generateAcquireTokenAccountKey = function (e, t) {
      return j + _.resourceDelimiter + "" + e + _.resourceDelimiter + t;
    }, e.generateAuthorityKey = function (e) {
      return q + _.resourceDelimiter + "" + e;
    }, e;
  }(),
      Pe = function () {
    function e(e, t, n, r, o, i, a) {
      this.accountIdentifier = e, this.homeAccountIdentifier = t, this.userName = n, this.name = r, this.idToken = o, this.idTokenClaims = o, this.sid = i, this.environment = a;
    }

    return e.createAccount = function (t, n) {
      var r,
          o = t.objectId || t.subject,
          i = n ? n.uid : "",
          a = n ? n.utid : "";
      return J.isEmpty(i) || J.isEmpty(a) || (r = J.base64Encode(i) + "." + J.base64Encode(a)), new e(o, r, t.preferredName, t.name, t.claims, t.sid, t.issuer);
    }, e;
  }(),
      Ae = function () {
    function e() {}

    return e.prototype.sendRequestAsync = function (e, t, n) {
      var r = this;
      return new Promise(function (n, o) {
        var i = new XMLHttpRequest();
        if (i.open(t, e, !0), i.onload = function (e) {
          (i.status < 200 || i.status >= 300) && o(r.handleError(i.responseText));

          try {
            var t = JSON.parse(i.responseText);
          } catch (e) {
            o(r.handleError(i.responseText));
          }

          n(t);
        }, i.onerror = function (e) {
          o(i.status);
        }, "GET" !== t) throw "not implemented";
        i.send();
      });
    }, e.prototype.handleError = function (e) {
      var t;

      try {
        if ((t = JSON.parse(e)).error) return t.error;
        throw e;
      } catch (t) {
        return e;
      }
    }, e;
  }();

  !function (e) {
    e[e.Aad = 0] = "Aad", e[e.Adfs = 1] = "Adfs", e[e.B2C = 2] = "B2C";
  }(x || (x = {}));

  var Oe,
      Re = function (e) {
    function t(t, n) {
      return e.call(this, t, n) || this;
    }

    return O(t, e), Object.defineProperty(t.prototype, "AadInstanceDiscoveryEndpointUrl", {
      get: function get() {
        return t.AadInstanceDiscoveryEndpoint + "?api-version=1.0&authorization_endpoint=" + this.CanonicalAuthority + "oauth2/v2.0/authorize";
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(t.prototype, "AuthorityType", {
      get: function get() {
        return x.Aad;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.GetOpenIdConfigurationEndpointAsync = function () {
      var e = this,
          t = new Promise(function (t, n) {
        return t(e.DefaultOpenIdConfigurationEndpoint);
      });
      if (!this.IsValidationEnabled) return t;
      var n = this.CanonicalAuthorityUrlComponents.HostNameAndPort;
      return this.IsInTrustedHostList(n) ? t : new Ae().sendRequestAsync(this.AadInstanceDiscoveryEndpointUrl, "GET", !0).then(function (e) {
        return e.tenant_discovery_endpoint;
      });
    }, t.prototype.IsInTrustedHostList = function (e) {
      return U[e.toLowerCase()];
    }, t.AadInstanceDiscoveryEndpoint = "https://login.microsoftonline.com/common/discovery/instance", t;
  }(function () {
    function e(e, t) {
      this.IsValidationEnabled = t, this.CanonicalAuthority = e, this.validateAsUri();
    }

    return Object.defineProperty(e.prototype, "Tenant", {
      get: function get() {
        return this.CanonicalAuthorityUrlComponents.PathSegments[0];
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "AuthorizationEndpoint", {
      get: function get() {
        return this.validateResolved(), this.tenantDiscoveryResponse.AuthorizationEndpoint.replace("{tenant}", this.Tenant);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "EndSessionEndpoint", {
      get: function get() {
        return this.validateResolved(), this.tenantDiscoveryResponse.EndSessionEndpoint.replace("{tenant}", this.Tenant);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "SelfSignedJwtAudience", {
      get: function get() {
        return this.validateResolved(), this.tenantDiscoveryResponse.Issuer.replace("{tenant}", this.Tenant);
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.validateResolved = function () {
      if (!this.tenantDiscoveryResponse) throw "Please call ResolveEndpointsAsync first";
    }, Object.defineProperty(e.prototype, "CanonicalAuthority", {
      get: function get() {
        return this.canonicalAuthority;
      },
      set: function set(e) {
        this.canonicalAuthority = J.CanonicalizeUri(e), this.canonicalAuthorityUrlComponents = null;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "CanonicalAuthorityUrlComponents", {
      get: function get() {
        return this.canonicalAuthorityUrlComponents || (this.canonicalAuthorityUrlComponents = J.GetUrlComponents(this.CanonicalAuthority)), this.canonicalAuthorityUrlComponents;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "DefaultOpenIdConfigurationEndpoint", {
      get: function get() {
        return this.CanonicalAuthority + "v2.0/.well-known/openid-configuration";
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.validateAsUri = function () {
      var e;

      try {
        e = this.CanonicalAuthorityUrlComponents;
      } catch (e) {
        throw Te.invalidAuthorityType;
      }

      if (!e.Protocol || "https:" !== e.Protocol.toLowerCase()) throw Te.authorityUriInsecure;
      if (!e.PathSegments || e.PathSegments.length < 1) throw Te.authorityUriInvalidPath;
    }, e.prototype.DiscoverEndpoints = function (e) {
      return new Ae().sendRequestAsync(e, "GET", !0).then(function (e) {
        return {
          AuthorizationEndpoint: e.authorization_endpoint,
          EndSessionEndpoint: e.end_session_endpoint,
          Issuer: e.issuer
        };
      });
    }, e.prototype.resolveEndpointsAsync = function () {
      var e = this,
          t = "";
      return this.GetOpenIdConfigurationEndpointAsync().then(function (n) {
        return t = n, e.DiscoverEndpoints(t);
      }).then(function (t) {
        return e.tenantDiscoveryResponse = t, e;
      });
    }, e;
  }()),
      xe = function (e) {
    function t(t, n) {
      var r = e.call(this, t, n) || this,
          o = J.GetUrlComponents(t),
          i = o.PathSegments;
      if (i.length < 3) throw Te.b2cAuthorityUriInvalidPath;
      return r.CanonicalAuthority = "https://" + o.HostNameAndPort + "/" + i[0] + "/" + i[1] + "/" + i[2] + "/", r;
    }

    return O(t, e), Object.defineProperty(t.prototype, "AuthorityType", {
      get: function get() {
        return x.B2C;
      },
      enumerable: !0,
      configurable: !0
    }), t.prototype.GetOpenIdConfigurationEndpointAsync = function () {
      var e = this,
          t = new Promise(function (t, n) {
        return t(e.DefaultOpenIdConfigurationEndpoint);
      });
      return this.IsValidationEnabled ? this.IsInTrustedHostList(this.CanonicalAuthorityUrlComponents.HostNameAndPort) ? t : new Promise(function (e, t) {
        return t(Te.unsupportedAuthorityValidation);
      }) : t;
    }, t.B2C_PREFIX = "tfp", t;
  }(Re),
      _e = function () {
    function e() {}

    return e.DetectAuthorityFromUrl = function (e) {
      switch (e = J.CanonicalizeUri(e), J.GetUrlComponents(e).PathSegments[0]) {
        case "tfp":
          return x.B2C;

        case "adfs":
          return x.Adfs;

        default:
          return x.Aad;
      }
    }, e.CreateInstance = function (t, n) {
      if (J.isEmpty(t)) return null;

      switch (e.DetectAuthorityFromUrl(t)) {
        case x.B2C:
          return new xe(t, n);

        case x.Aad:
          return new Re(t, n);

        default:
          throw Te.invalidAuthorityType;
      }
    }, e;
  }();

  !function (e) {
    e[e.Error = 0] = "Error", e[e.Warning = 1] = "Warning", e[e.Info = 2] = "Info", e[e.Verbose = 3] = "Verbose";
  }(Oe || (Oe = {}));

  var qe = function () {
    function e(e, t) {
      void 0 === t && (t = {}), this.level = Oe.Info;
      var n = t.correlationId,
          r = void 0 === n ? "" : n,
          o = t.level,
          i = void 0 === o ? Oe.Info : o,
          a = t.piiLoggingEnabled,
          s = void 0 !== a && a;
      this.localCallback = e, this.correlationId = r, this.level = i, this.piiLoggingEnabled = s;
    }

    return e.prototype.logMessage = function (e, t, n) {
      if (!(e > this.level || !this.piiLoggingEnabled && n)) {
        var r,
            o = new Date().toUTCString();
        r = J.isEmpty(this.correlationId) ? o + ":" + J.getLibraryVersion() + "-" + Oe[e] + " " + t : o + ":" + this.correlationId + "-" + J.getLibraryVersion() + "-" + Oe[e] + " " + t, this.executeCallback(e, r, n);
      }
    }, e.prototype.executeCallback = function (e, t, n) {
      this.localCallback && this.localCallback(e, t, n);
    }, e.prototype.error = function (e) {
      this.logMessage(Oe.Error, e, !1);
    }, e.prototype.errorPii = function (e) {
      this.logMessage(Oe.Error, e, !0);
    }, e.prototype.warning = function (e) {
      this.logMessage(Oe.Warning, e, !1);
    }, e.prototype.warningPii = function (e) {
      this.logMessage(Oe.Warning, e, !0);
    }, e.prototype.info = function (e) {
      this.logMessage(Oe.Info, e, !1);
    }, e.prototype.infoPii = function (e) {
      this.logMessage(Oe.Info, e, !0);
    }, e.prototype.verbose = function (e) {
      this.logMessage(Oe.Verbose, e, !1);
    }, e.prototype.verbosePii = function (e) {
      this.logMessage(Oe.Verbose, e, !0);
    }, e.prototype.isPiiLoggingEnabled = function () {
      return this.piiLoggingEnabled;
    }, e;
  }(),
      je = {
    clientId: "",
    authority: null,
    validateAuthority: !0,
    redirectUri: function redirectUri() {
      return J.getDefaultRedirectUri();
    },
    postLogoutRedirectUri: function postLogoutRedirectUri() {
      return J.getDefaultRedirectUri();
    },
    navigateToLoginRequestUrl: !0
  },
      Ue = {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: !1
  },
      Le = {
    logger: new qe(null),
    loadFrameTimeout: 6e3,
    tokenRenewalOffsetSeconds: 300,
    navigateFrameWait: 500
  },
      Me = {
    isAngular: !1,
    unprotectedResources: new Array(),
    protectedResourceMap: new Map()
  };

  var Ne = {
    code: "server_unavailable",
    desc: "Server is temporarily unavailable."
  },
      De = {
    code: "unknown_server_error"
  },
      He = function (e) {
    function t(n, r) {
      var o = e.call(this, n, r) || this;
      return o.name = "ServerError", Object.setPrototypeOf(o, t.prototype), o;
    }

    return O(t, e), t.createServerUnavailableError = function () {
      return new t(Ne.code, Ne.desc);
    }, t.createUnknownServerError = function (e) {
      return new t(De.code, e);
    }, t;
  }(Z),
      Fe = {
    code: "interaction_required"
  },
      We = {
    code: "consent_required"
  },
      Ve = {
    code: "login_required"
  },
      Ke = function (e) {
    function t(n, r) {
      var o = e.call(this, n, r) || this;
      return o.name = "InteractionRequiredAuthError", Object.setPrototypeOf(o, t.prototype), o;
    }

    return O(t, e), t.isInteractionRequiredError = function (e) {
      var t = [Fe.code, We.code, Ve.code];
      return e && t.indexOf(e) > -1;
    }, t.createLoginRequiredAuthError = function (e) {
      return new t(Ve.code, e);
    }, t.createInteractionRequiredAuthError = function (e) {
      return new t(Fe.code, e);
    }, t.createConsentRequiredAuthError = function (e) {
      return new t(We.code, e);
    }, t;
  }(He);

  function ze(e) {
    return {
      uniqueId: "",
      tenantId: "",
      tokenType: "",
      idToken: null,
      idTokenClaims: null,
      accessToken: "",
      scopes: null,
      expiresOn: null,
      account: null,
      accountState: e
    };
  }

  var Ge = "event_name",
      Be = "start_time",
      Je = "elapsed_time",
      Qe = {
    MsalCorrelationIdConstStrKey: "Microsoft.MSAL.correlation_id",
    ApiTelemIdConstStrKey: "msal.api_telem_id",
    ApiIdConstStrKey: "msal.api_id",
    BrokerAppConstStrKey: "Microsoft_MSAL_broker_app",
    CacheEventCountConstStrKey: "Microsoft_MSAL_cache_event_count",
    HttpEventCountTelemetryBatchKey: "Microsoft_MSAL_http_event_count",
    IdpConstStrKey: "Microsoft_MSAL_idp",
    IsSilentTelemetryBatchKey: "",
    IsSuccessfulConstStrKey: "Microsoft_MSAL_is_successful",
    ResponseTimeConstStrKey: "Microsoft_MSAL_response_time",
    TenantIdConstStrKey: "Microsoft_MSAL_tenant_id",
    UiEventCountTelemetryBatchKey: "Microsoft_MSAL_ui_event_count"
  },
      $e = function $e(e) {
    return "msal." + (e || "");
  },
      Ye = function (e) {
    function t(t, n, r, o) {
      var i = e.call(this, $e("default_event"), n) || this;
      return i.event[$e("client_id")] = r, i.event[$e("sdk_plaform")] = t.sdk, i.event[$e("sdk_version")] = t.sdkVersion, i.event[$e("application_name")] = t.applicationName, i.event[$e("application_version")] = t.applicationVersion, i.event["" + Qe.UiEventCountTelemetryBatchKey] = i.getEventCount($e("ui_event"), o), i.event["" + Qe.HttpEventCountTelemetryBatchKey] = i.getEventCount($e("http_event"), o), i.event["" + Qe.CacheEventCountConstStrKey] = i.getEventCount($e("cache_event"), o), i;
    }

    return O(t, e), t.prototype.getEventCount = function (e, t) {
      return t[e] ? t[e] : 0;
    }, t;
  }(function () {
    function e(e, t) {
      var r;
      this.startTimestamp = Date.now(), this.eventId = n.v4(), this.event = ((r = {})[$e(Ge)] = e, r[$e(Be)] = this.startTimestamp, r[$e(Je)] = -1, r["" + Qe.MsalCorrelationIdConstStrKey] = t, r);
    }

    return e.prototype.setElapsedTime = function (e) {
      this.event[$e(Je)] = e;
    }, e.prototype.stop = function () {
      this.setElapsedTime(+Date.now() - +this.startTimestamp);
    }, Object.defineProperty(e.prototype, "telemetryCorrelationId", {
      get: function get() {
        return this.event["" + Qe.MsalCorrelationIdConstStrKey];
      },
      set: function set(e) {
        this.event["" + Qe.MsalCorrelationIdConstStrKey] = e;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(e.prototype, "eventName", {
      get: function get() {
        return this.event[$e(Ge)];
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.get = function () {
      return _R({}, this.event, {
        eventId: this.eventId
      });
    }, e;
  }()),
      Xe = function Xe(e) {
    return e.telemetryCorrelationId + "-" + e.eventId + "-" + e.eventName;
  },
      Ze = function () {
    function e(e, t) {
      this.completedEvents = {}, this.inProgressEvents = {}, this.eventCountByCorrelationId = {}, this.onlySendFailureTelemetry = !1, this.telemetryPlatform = e.platform, this.clientId = e.clientId, this.onlySendFailureTelemetry = e.onlySendFailureTelemetry, this.telemetryEmitter = t;
    }

    return e.prototype.startEvent = function (e) {
      if (this.telemetryEmitter) {
        var t = Xe(e);
        this.inProgressEvents[t] = e;
      }
    }, e.prototype.stopEvent = function (e) {
      var t = Xe(e);

      if (this.telemetryEmitter && this.inProgressEvents[t]) {
        e.stop(), this.incrementEventCount(e);
        var n = this.completedEvents[e.telemetryCorrelationId];
        this.completedEvents[e.telemetryCorrelationId] = (n || []).concat([e]), delete this.inProgressEvents[t];
      }
    }, e.prototype.flush = function (e) {
      var t = this;

      if (this.telemetryEmitter && this.completedEvents[e]) {
        var n = this.getOrphanedEvents(e);
        n.forEach(function (e) {
          return t.incrementEventCount(e);
        });
        var r = this.completedEvents[e].concat(n);
        delete this.completedEvents[e];
        var o = this.eventCountByCorrelationId[e];

        if (delete this.eventCountByCorrelationId[e], r && r.length) {
          var i = new Ye(this.telemetryPlatform, e, this.clientId, o),
              a = r.concat([i]);
          this.telemetryEmitter(a.map(function (e) {
            return e.get();
          }));
        }
      }
    }, e.prototype.incrementEventCount = function (e) {
      var t,
          n = e.eventName,
          r = this.eventCountByCorrelationId[e.telemetryCorrelationId];
      r ? r[n] = r[n] ? r[n] + 1 : 1 : this.eventCountByCorrelationId[e.telemetryCorrelationId] = ((t = {})[n] = 1, t);
    }, e.prototype.getOrphanedEvents = function (e) {
      var t = this;
      return Object.keys(this.inProgressEvents).reduce(function (n, r) {
        if (-1 !== r.indexOf(e)) {
          var o = t.inProgressEvents[r];
          return delete t.inProgressEvents[r], n.concat([o]);
        }

        return n;
      }, []);
    }, e;
  }(),
      et = "https://login.microsoftonline.com/common",
      tt = "id_token",
      nt = "token",
      rt = "id_token token",
      ot = function ot(e, t, n) {
    var r = n.value;
    return n.value = function () {
      for (var e = [], t = 0; t < arguments.length; t++) {
        e[t] = arguments[t];
      }

      return this.isInIframe() ? new Promise(function () {}) : r.apply(this, e);
    }, n;
  },
      it = function () {
    function e(e) {
      var t, n, r, o, i, a, s, c;
      this.authResponseCallback = null, this.tokenReceivedCallback = null, this.errorReceivedCallback = null, this.config = (n = (t = e).auth, r = t.cache, o = void 0 === r ? {} : r, i = t.system, a = void 0 === i ? {} : i, s = t.framework, c = void 0 === s ? {} : s, {
        auth: _R({}, je, n),
        cache: _R({}, Ue, o),
        system: _R({}, Le, a),
        framework: _R({}, Me, c)
      }), this.redirectCallbacksSet = !1, this.logger = this.config.system.logger, this.clientId = this.config.auth.clientId, this.inCookie = this.config.cache.storeAuthStateInCookie, this.telemetryManager = this.getTelemetryManagerFromConfig(this.config.system.telemetry, this.clientId), this.authority = this.config.auth.authority || et, this.loginInProgress = !1, this.acquireTokenInProgress = !1;

      try {
        this.cacheStorage = new Ee(this.config.cache.cacheLocation);
      } catch (e) {
        throw Ce.createInvalidCacheLocationConfigError(this.config.cache.cacheLocation);
      }

      window.openedWindows = [], window.activeRenewals = {}, window.renewStates = [], window.callbackMappedToRenewStates = {}, window.promiseMappedToRenewStates = {}, window.msal = this;
      var u = window.location.hash,
          l = this.urlContainsHash(u);
      this.config.framework.isAngular || l && this.handleAuthenticationResponse(u);
    }

    return Object.defineProperty(e.prototype, "authority", {
      get: function get() {
        return this.authorityInstance.CanonicalAuthority;
      },
      set: function set(e) {
        this.authorityInstance = _e.CreateInstance(e, this.config.auth.validateAuthority);
      },
      enumerable: !0,
      configurable: !0
    }), e.prototype.getAuthorityInstance = function () {
      return this.authorityInstance;
    }, e.prototype.handleRedirectCallback = function (e, t) {
      if (!e) throw this.redirectCallbacksSet = !1, Ce.createInvalidCallbackObjectError(e);

      if (t ? (this.tokenReceivedCallback = e, this.errorReceivedCallback = t, this.logger.warning("This overload for callback is deprecated - please change the format of the callbacks to a single callback as shown: (err: AuthError, response: AuthResponse).")) : this.authResponseCallback = e, this.redirectCallbacksSet = !0, !this.config.framework.isAngular) {
        var n = this.cacheStorage.getItem(_.urlHash);
        n && this.processCallBack(n, null);
      }
    }, e.prototype.authResponseHandler = function (e, t, n) {
      if (e === _.interactionTypeRedirect) this.errorReceivedCallback ? this.tokenReceivedCallback(t) : this.authResponseCallback && this.authResponseCallback(null, t);else {
        if (e !== _.interactionTypePopup) throw be.createInvalidInteractionTypeError();
        n(t);
      }
    }, e.prototype.authErrorHandler = function (e, t, n, r) {
      if (e === _.interactionTypeRedirect) this.errorReceivedCallback ? this.errorReceivedCallback(t, n.accountState) : this.authResponseCallback(t, n);else {
        if (e !== _.interactionTypePopup) throw be.createInvalidInteractionTypeError();
        r(t);
      }
    }, e.prototype.loginRedirect = function (e) {
      if (!this.redirectCallbacksSet) throw Ce.createRedirectCallbacksNotSetError();
      this.acquireTokenInteractive(_.interactionTypeRedirect, !0, e);
    }, e.prototype.acquireTokenRedirect = function (e) {
      if (!e) throw Ce.createEmptyRequestError();
      if (!this.redirectCallbacksSet) throw Ce.createRedirectCallbacksNotSetError();
      this.acquireTokenInteractive(_.interactionTypeRedirect, !1, e);
    }, e.prototype.loginPopup = function (e) {
      var t = this;
      return new Promise(function (n, r) {
        t.acquireTokenInteractive(_.interactionTypePopup, !0, e, n, r);
      });
    }, e.prototype.acquireTokenPopup = function (e) {
      var t = this;
      if (!e) throw Ce.createEmptyRequestError();
      return new Promise(function (n, r) {
        t.acquireTokenInteractive(_.interactionTypePopup, !1, e, n, r);
      });
    }, e.prototype.acquireTokenInteractive = function (e, t, n, r, o) {
      var i = this;

      if (this.loginInProgress || this.acquireTokenInProgress) {
        var a = this.loginInProgress ? be.createLoginInProgressError() : be.createAcquireTokenInProgressError(),
            s = ze(this.getAccountState(n && n.state));
        this.authErrorHandler(e, a, s, o);
      } else {
        var c = t ? this.appendScopes(n) : n.scopes;
        this.validateInputScope(c, !t);
        var u = n && n.account && !t ? n.account : this.getAccount();
        if (u || J.isSSOParam(n)) this.acquireTokenHelper(u, e, t, n, c, r, o);else {
          if (!t) throw this.logger.info("User login is required"), be.createUserLoginRequiredError();

          if (this.extractADALIdToken() && !c) {
            this.logger.info("ADAL's idToken exists. Extracting login information from ADAL's idToken ");
            var l = this.buildIDTokenRequest(n);
            this.silentLogin = !0, this.acquireTokenSilent(l).then(function (t) {
              i.silentLogin = !1, i.logger.info("Unified cache call is successful"), i.authResponseHandler(e, t, r);
            }, function (a) {
              i.silentLogin = !1, i.logger.error("Error occurred during unified cache ATS: " + a), i.acquireTokenHelper(null, e, t, n, c, r, o);
            });
          } else this.acquireTokenHelper(null, e, t, n, c, r, o);
        }
      }
    }, e.prototype.acquireTokenHelper = function (e, t, n, r, o, i, a) {
      var s = this;
      n ? this.loginInProgress = !0 : this.acquireTokenInProgress = !0;
      var c,
          u,
          l = o ? o.join(" ").toLowerCase() : this.clientId.toLowerCase(),
          d = !n && r && r.authority ? _e.CreateInstance(r.authority, this.config.auth.validateAuthority) : this.authorityInstance;
      (t !== _.interactionTypePopup || (u = this.openWindow("about:blank", "_blank", 1, this, i, a))) && d.resolveEndpointsAsync().then(function () {
        var p,
            h = n ? tt : s.getTokenType(e, o, !1);
        n && ((p = s.cacheStorage.getItem(_.angularLoginRequest)) && "" !== p ? s.cacheStorage.setItem(_.angularLoginRequest, "") : p = window.location.href), c = new Y(d, s.clientId, o, h, s.getRedirectUri(), r && r.state), s.updateCacheEntries(c, e, p);

        var f = (c = s.populateQueryParams(e, r, c)).createNavigateUrl(o) + _.response_mode_fragment;

        if (t === _.interactionTypeRedirect) n || s.cacheStorage.setItem(_.stateAcquireToken, c.state, s.inCookie);else {
          if (t !== _.interactionTypePopup) throw be.createInvalidInteractionTypeError();
          window.renewStates.push(c.state), window.requestType = n ? _.login : _.renewToken, s.registerCallback(c.state, l, i, a);
        }
        s.navigateWindow(f, u);
      }).catch(function (e) {
        s.logger.warning("could not resolve endpoints"), s.authErrorHandler(t, be.createEndpointResolutionError(e.toString), ze(r.state), a), u && u.close();
      });
    }, e.prototype.acquireTokenSilent = function (e) {
      var t = this;
      if (!e) throw Ce.createEmptyRequestError();
      return new Promise(function (n, r) {
        t.validateInputScope(e.scopes, !0);
        var o = e.scopes.join(" ").toLowerCase(),
            i = e.account || t.getAccount(),
            a = t.cacheStorage.getItem(_.adalIdToken);
        if (!i && !e.sid && !e.loginHint && J.isEmpty(a)) return t.logger.info("User login is required"), r(be.createUserLoginRequiredError());
        var s = t.getTokenType(i, e.scopes, !0),
            c = new Y(_e.CreateInstance(e.authority, t.config.auth.validateAuthority), t.clientId, e.scopes, s, t.getRedirectUri(), e && e.state);
        if (J.isSSOParam(e) || i) c = t.populateQueryParams(i, e, c);else if (!i && !J.isEmpty(a)) {
          var u = J.extractIdToken(a);
          t.logger.verbose("ADAL's idToken exists. Extracting login information from ADAL's idToken "), c = t.populateQueryParams(i, null, c, u);
        }
        var l,
            d,
            p = e.claimsRequest || c.claimsValue;
        if (!p && !e.forceRefresh) try {
          d = t.getCachedToken(c, i);
        } catch (e) {
          l = e;
        }
        if (d) return t.logger.info("Token is already in cache for scope:" + o), n(d), null;
        if (l) return t.logger.infoPii(l.errorCode + ":" + l.errorMessage), r(l), null;
        var h = void 0;
        return h = p ? "Skipped cache lookup since claims were given." : e.forceRefresh ? "Skipped cache lookup since request.forceRefresh option was set to true" : "Token is not in cache for scope:" + o, t.logger.verbose(h), c.authorityInstance || (c.authorityInstance = e.authority ? _e.CreateInstance(e.authority, t.config.auth.validateAuthority) : t.authorityInstance), c.authorityInstance.resolveEndpointsAsync().then(function () {
          window.activeRenewals[o] ? (t.logger.verbose("Renew token for scope: " + o + " is in progress. Registering callback"), t.registerCallback(window.activeRenewals[o], o, n, r)) : e.scopes && e.scopes.indexOf(t.clientId) > -1 && 1 === e.scopes.length ? (t.logger.verbose("renewing idToken"), t.renewIdToken(e.scopes, n, r, i, c)) : (t.logger.verbose("renewing accesstoken"), t.renewToken(e.scopes, n, r, i, c));
        }).catch(function (e) {
          return t.logger.warning("could not resolve endpoints"), r(be.createEndpointResolutionError(e.toString())), null;
        });
      });
    }, e.prototype.openWindow = function (e, t, n, r, o, i) {
      var a,
          s = this;

      try {
        a = this.openPopup(e, t, _.popUpWidth, _.popUpHeight);
      } catch (e) {
        return r.loginInProgress = !1, r.acquireTokenInProgress = !1, this.logger.info(re.code + ":" + re.desc), this.cacheStorage.setItem(_.msalError, re.code), this.cacheStorage.setItem(_.msalErrorDescription, re.desc), i && i(be.createPopupWindowError()), null;
      }

      window.openedWindows.push(a);
      var c = window.setInterval(function () {
        if (a && a.closed && (r.loginInProgress || r.acquireTokenInProgress)) {
          if (i && i(be.createUserCancelledError()), window.clearInterval(c), s.config.framework.isAngular) return void s.broadcast("msal:popUpClosed", le.code + _.resourceDelimiter + le.desc);
          r.loginInProgress = !1, r.acquireTokenInProgress = !1;
        }

        try {
          var e = a.location;

          if (-1 !== e.href.indexOf(s.getRedirectUri()) && (window.clearInterval(c), r.loginInProgress = !1, r.acquireTokenInProgress = !1, s.logger.info("Closing popup window"), s.config.framework.isAngular)) {
            s.broadcast("msal:popUpHashChanged", e.hash);

            for (var t = 0; t < window.openedWindows.length; t++) {
              window.openedWindows[t].close();
            }
          }
        } catch (e) {}
      }, n);
      return a;
    }, e.prototype.openPopup = function (e, t, n, r) {
      try {
        var o = window.screenLeft ? window.screenLeft : window.screenX,
            i = window.screenTop ? window.screenTop : window.screenY,
            a = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
            s = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
            c = a / 2 - n / 2 + o,
            u = s / 2 - r / 2 + i,
            l = window.open(e, t, "width=" + n + ", height=" + r + ", top=" + u + ", left=" + c);
        if (!l) throw be.createPopupWindowError();
        return l.focus && l.focus(), l;
      } catch (e) {
        throw this.logger.error("error opening popup " + e.message), this.loginInProgress = !1, this.acquireTokenInProgress = !1, be.createPopupWindowError(e.toString());
      }
    }, e.prototype.isInIframe = function () {
      return window.parent !== window;
    }, e.prototype.parentIsMsal = function () {
      return window.parent !== window && window.parent.msal;
    }, e.prototype.loadIframeTimeout = function (e, t, n) {
      var r = this,
          o = window.activeRenewals[n];
      this.logger.verbose("Set loading state to pending for: " + n + ":" + o), this.cacheStorage.setItem(_.renewStatus + o, _.tokenRenewStatusInProgress), this.loadFrame(e, t), setTimeout(function () {
        r.cacheStorage.getItem(_.renewStatus + o) === _.tokenRenewStatusInProgress && (r.logger.verbose("Loading frame has timed out after: " + r.config.system.loadFrameTimeout / 1e3 + " seconds for scope " + n + ":" + o), o && window.callbackMappedToRenewStates[o] && window.callbackMappedToRenewStates[o](null, be.createTokenRenewalTimeoutError()), r.cacheStorage.setItem(_.renewStatus + o, _.tokenRenewStatusCancelled));
      }, this.config.system.loadFrameTimeout);
    }, e.prototype.loadFrame = function (e, t) {
      var n = this;
      this.logger.info("LoadFrame: " + t);
      var r = t;
      setTimeout(function () {
        var o = n.addHiddenIFrame(r);
        "" !== o.src && "about:blank" !== o.src || (o.src = e, n.logger.infoPii("Frame Name : " + t + " Navigated to: " + e));
      }, this.config.system.navigateFrameWait);
    }, e.prototype.addHiddenIFrame = function (e) {
      if (void 0 === e) return null;
      this.logger.info("Add msal frame to document:" + e);
      var t = document.getElementById(e);

      if (!t) {
        if (document.createElement && document.documentElement && -1 === window.navigator.userAgent.indexOf("MSIE 5.0")) {
          var n = document.createElement("iframe");
          n.setAttribute("id", e), n.style.visibility = "hidden", n.style.position = "absolute", n.style.width = n.style.height = "0", n.style.border = "0", t = document.getElementsByTagName("body")[0].appendChild(n);
        } else document.body && document.body.insertAdjacentHTML && document.body.insertAdjacentHTML("beforeend", "<iframe name='" + e + "' id='" + e + "' style='display:none'></iframe>");

        window.frames && window.frames[e] && (t = window.frames[e]);
      }

      return t;
    }, e.prototype.addHintParameters = function (e, t, n) {
      var r = e || this.getAccount();

      if (r && !t[L]) {
        if (!t[M] && r.sid && n.promptValue === G.NONE) t = J.addSSOParameter(L, r.sid, t);else !t[M] && r.userName && !J.isEmpty(r.userName) && (t = J.addSSOParameter(M, r.userName, t));
        !t[K] && !t[V] && (t = J.addSSOParameter(W, r.homeAccountIdentifier, t));
      }

      return t;
    }, e.prototype.navigateWindow = function (e, t) {
      if (!e || J.isEmpty(e)) throw this.logger.info("Navigate url is empty"), Z.createUnexpectedError("Navigate url is empty");
      var n = t || window,
          r = t ? "Navigated Popup window to:" + e : "Navigate to:" + e;
      this.logger.infoPii(r), n.location.replace(e);
    }, e.prototype.registerCallback = function (e, t, n, r) {
      var o = this;
      window.activeRenewals[t] = e, window.promiseMappedToRenewStates[e] || (window.promiseMappedToRenewStates[e] = []), window.promiseMappedToRenewStates[e].push({
        resolve: n,
        reject: r
      }), window.callbackMappedToRenewStates[e] || (window.callbackMappedToRenewStates[e] = function (n, r) {
        window.activeRenewals[t] = null;

        for (var i = 0; i < window.promiseMappedToRenewStates[e].length; ++i) {
          try {
            if (r) window.promiseMappedToRenewStates[e][i].reject(r);else {
              if (!n) throw Z.createUnexpectedError("Error and response are both null");
              window.promiseMappedToRenewStates[e][i].resolve(n);
            }
          } catch (e) {
            o.logger.warning(e);
          }
        }

        window.promiseMappedToRenewStates[e] = null, window.callbackMappedToRenewStates[e] = null;
      });
    }, e.prototype.logout = function () {
      var e = this;
      this.clearCache(), this.account = null;
      var t = "";
      this.getPostLogoutRedirectUri() && (t = "post_logout_redirect_uri=" + encodeURIComponent(this.getPostLogoutRedirectUri())), this.authorityInstance.resolveEndpointsAsync().then(function (n) {
        var r = n.EndSessionEndpoint ? n.EndSessionEndpoint + "?" + t : e.authority + "oauth2/v2.0/logout?" + t;
        e.navigateWindow(r);
      });
    }, e.prototype.clearCache = function () {
      window.renewStates = [];

      for (var e = this.cacheStorage.getAllAccessTokens(_.clientId, _.homeAccountIdentifier), t = 0; t < e.length; t++) {
        this.cacheStorage.removeItem(JSON.stringify(e[t].key));
      }

      this.cacheStorage.resetCacheItems(), this.cacheStorage.clearCookie();
    }, e.prototype.clearCacheForScope = function (e) {
      for (var t = this.cacheStorage.getAllAccessTokens(_.clientId, _.homeAccountIdentifier), n = 0; n < t.length; n++) {
        var r = t[n];
        r.value.accessToken === e && this.cacheStorage.removeItem(JSON.stringify(r.key));
      }
    }, e.prototype.isCallback = function (e) {
      return this.logger.info("isCallback will be deprecated in favor of urlContainsHash in MSAL.js v2.0."), this.urlContainsHash(e);
    }, e.prototype.urlContainsHash = function (e) {
      var t = this.deserializeHash(e);
      return t.hasOwnProperty(_.errorDescription) || t.hasOwnProperty(_.error) || t.hasOwnProperty(_.accessToken) || t.hasOwnProperty(_.idToken);
    }, e.prototype.processCallBack = function (e, t, n) {
      var r, o;
      this.logger.info("Processing the callback from redirect response"), t || (t = this.getResponseState(e));

      try {
        r = this.saveTokenFromHash(e, t);
      } catch (e) {
        o = e;
      }

      this.cacheStorage.removeItem(_.urlHash);

      try {
        this.cacheStorage.clearCookie();
        var i = this.getAccountState(t.state);

        if (r) {
          if (t.requestType === _.renewToken || r.accessToken ? (window.parent !== window ? this.logger.verbose("Window is in iframe, acquiring token silently") : this.logger.verbose("acquiring token interactive in progress"), r.tokenType = _.accessToken) : t.requestType === _.login && (r.tokenType = _.idToken), !n) return void this.authResponseHandler(_.interactionTypeRedirect, r);
        } else if (!n) return void this.authErrorHandler(_.interactionTypeRedirect, o, ze(i));

        n(r, o);
      } catch (e) {
        throw this.logger.error("Error occurred in token received callback function: " + e), be.createErrorInCallbackFunction(e.toString());
      }
    }, e.prototype.handleAuthenticationResponse = function (e) {
      null == e && (e = window.location.hash);
      var t = null,
          n = !1,
          r = !1;

      try {
        r = window.opener && window.opener.msal && window.opener.msal !== window.msal;
      } catch (e) {
        r = !1;
      }

      r ? (t = window.opener.msal, n = !0) : window.parent && window.parent.msal && (t = window.parent.msal);
      var o = t.getResponseState(e),
          i = null;
      if (t.logger.info("Returned from redirect url"), this.parentIsMsal()) i = window.parent.callbackMappedToRenewStates[o.state];else if (r) i = window.opener.callbackMappedToRenewStates[o.state];else {
        if (i = null, t.config.auth.navigateToLoginRequestUrl) return t.cacheStorage.setItem(_.urlHash, e), void (window.parent !== window || n || (window.location.href = t.cacheStorage.getItem(_.loginRequest, t.inCookie)));
        if (window.location.hash = "", !this.redirectCallbacksSet) return void t.cacheStorage.setItem(_.urlHash, e);
      }
      if (t.processCallBack(e, o, i), r) for (var a = 0; a < window.opener.openedWindows.length; a++) {
        window.opener.openedWindows[a].close();
      }
    }, e.prototype.deserializeHash = function (e) {
      var t = J.getHashFromUrl(e);
      return J.deserialize(t);
    }, e.prototype.getResponseState = function (e) {
      var t,
          n = this.deserializeHash(e);
      if (!n) throw Z.createUnexpectedError("Hash was not parsed correctly.");
      if (!n.hasOwnProperty("state")) throw Z.createUnexpectedError("Hash does not contain state.");
      if ((t = {
        requestType: _.unknown,
        state: n.state,
        stateMatch: !1
      }).state === this.cacheStorage.getItem(_.stateLogin, this.inCookie) || t.state === this.silentAuthenticationState) return t.requestType = _.login, t.stateMatch = !0, t;
      if (t.state === this.cacheStorage.getItem(_.stateAcquireToken, this.inCookie)) return t.requestType = _.renewToken, t.stateMatch = !0, t;

      if (!t.stateMatch) {
        t.requestType = window.requestType;

        for (var r = window.renewStates, o = 0; o < r.length; o++) {
          if (r[o] === t.state) {
            t.stateMatch = !0;
            break;
          }
        }
      }

      return t;
    }, e.prototype.getCachedToken = function (e, t) {
      var n = null,
          r = e.scopes,
          o = this.cacheStorage.getAllAccessTokens(this.clientId, t ? t.homeAccountIdentifier : null);
      if (0 === o.length) return null;
      var i = [];

      if (e.authority) {
        for (a = 0; a < o.length; a++) {
          c = (s = o[a]).key.scopes.split(" ");
          J.containsScope(c, r) && J.CanonicalizeUri(s.key.authority) === e.authority && i.push(s);
        }

        if (0 === i.length) return null;
        if (1 !== i.length) throw be.createMultipleMatchingTokensInCacheError(r.toString());
        n = i[0];
      } else {
        for (var a = 0; a < o.length; a++) {
          var s,
              c = (s = o[a]).key.scopes.split(" ");
          J.containsScope(c, r) && i.push(s);
        }

        if (1 === i.length) n = i[0], e.authorityInstance = _e.CreateInstance(n.key.authority, this.config.auth.validateAuthority);else {
          if (i.length > 1) throw be.createMultipleMatchingTokensInCacheError(r.toString());
          var u = this.getUniqueAuthority(o, "authority");
          if (u.length > 1) throw be.createMultipleAuthoritiesInCacheError(r.toString());
          e.authorityInstance = _e.CreateInstance(u[0], this.config.auth.validateAuthority);
        }
      }

      if (null != n) {
        var l = Number(n.value.expiresIn),
            d = this.config.system.tokenRenewalOffsetSeconds || 300;

        if (l && l > J.now() + d) {
          var p = new Ie(n.value.idToken);
          if (!t && !(t = this.getAccount())) throw Z.createUnexpectedError("Account should not be null here.");
          var h = this.getAccountState(e.state),
              f = {
            uniqueId: "",
            tenantId: "",
            tokenType: n.value.idToken === n.value.accessToken ? _.idToken : _.accessToken,
            idToken: p,
            idTokenClaims: p.claims,
            accessToken: n.value.accessToken,
            scopes: n.key.scopes.split(" "),
            expiresOn: new Date(1e3 * l),
            account: t,
            accountState: h
          };
          return J.setResponseIdToken(f, p), f;
        }

        return this.cacheStorage.removeItem(JSON.stringify(i[0].key)), null;
      }

      return null;
    }, e.prototype.getUniqueAuthority = function (e, t) {
      var n = [],
          r = [];
      return e.forEach(function (e) {
        e.key.hasOwnProperty(t) && -1 === r.indexOf(e.key[t]) && (r.push(e.key[t]), n.push(e.key[t]));
      }), n;
    }, e.prototype.extractADALIdToken = function () {
      var e = this.cacheStorage.getItem(_.adalIdToken);
      return J.isEmpty(e) ? null : J.extractIdToken(e);
    }, e.prototype.renewToken = function (e, t, n, r, o) {
      var i = e.join(" ").toLowerCase();
      this.logger.verbose("renewToken is called for scope:" + i);
      var a = this.addHiddenIFrame("msalRenewFrame" + i);
      this.updateCacheEntries(o, r), this.logger.verbose("Renew token Expected state: " + o.state);

      var s = J.urlRemoveQueryStringParameter(o.createNavigateUrl(e), _.prompt) + _.prompt_none;

      window.renewStates.push(o.state), window.requestType = _.renewToken, this.registerCallback(o.state, i, t, n), this.logger.infoPii("Navigate to:" + s), a.src = "about:blank", this.loadIframeTimeout(s, "msalRenewFrame" + i, i);
    }, e.prototype.renewIdToken = function (e, t, n, r, o) {
      this.logger.info("renewidToken is called");
      var i = this.addHiddenIFrame("msalIdTokenFrame");
      this.updateCacheEntries(o, r), this.logger.verbose("Renew Idtoken Expected state: " + o.state);

      var a = J.urlRemoveQueryStringParameter(o.createNavigateUrl(e), _.prompt) + _.prompt_none;

      this.silentLogin ? (window.requestType = _.login, this.silentAuthenticationState = o.state) : (window.requestType = _.renewToken, window.renewStates.push(o.state)), this.registerCallback(o.state, this.clientId, t, n), this.logger.infoPii("Navigate to:" + a), i.src = "about:blank", this.loadIframeTimeout(a, "msalIdTokenFrame", this.clientId);
    }, e.prototype.saveAccessToken = function (e, t, n, r, o) {
      var i,
          a,
          s = _R({}, e),
          c = new ke(r);

      if (n.hasOwnProperty("scope")) {
        for (var u = (i = n.scope).split(" "), l = this.cacheStorage.getAllAccessTokens(this.clientId, t), d = 0; d < l.length; d++) {
          var p = l[d];

          if (p.key.homeAccountIdentifier === e.account.homeAccountIdentifier) {
            var h = p.key.scopes.split(" ");
            J.isIntersectingScopes(h, u) && this.cacheStorage.removeItem(JSON.stringify(p.key));
          }
        }

        var f = J.parseExpiresIn(n[_.expiresIn]);
        a = J.now() + f;
        var g = new Q(t, this.clientId, i, c.uid, c.utid),
            m = new $(n[_.accessToken], o.rawIdToken, a.toString(), r);
        this.cacheStorage.setItem(JSON.stringify(g), JSON.stringify(m)), s.accessToken = n[_.accessToken], s.scopes = u;
      } else {
        i = this.clientId;
        g = new Q(t, this.clientId, i, c.uid, c.utid);
        a = Number(o.expiration);
        m = new $(n[_.idToken], n[_.idToken], a.toString(), r);
        this.cacheStorage.setItem(JSON.stringify(g), JSON.stringify(m)), s.scopes = [i], s.accessToken = n[_.idToken];
      }

      return a ? s.expiresOn = new Date(1e3 * a) : this.logger.error("Could not parse expiresIn parameter"), s;
    }, e.prototype.saveTokenFromHash = function (e, t) {
      this.logger.info("State status:" + t.stateMatch + "; Request type:" + t.requestType), this.cacheStorage.setItem(_.msalError, ""), this.cacheStorage.setItem(_.msalErrorDescription, "");
      var n,
          r = {
        uniqueId: "",
        tenantId: "",
        tokenType: "",
        idToken: null,
        idTokenClaims: null,
        accessToken: null,
        scopes: [],
        expiresOn: null,
        account: null,
        accountState: ""
      },
          o = this.deserializeHash(e),
          i = "",
          a = "",
          s = null;

      if (o.hasOwnProperty(_.errorDescription) || o.hasOwnProperty(_.error)) {
        if (this.logger.infoPii("Error :" + o[_.error] + "; Error description:" + o[_.errorDescription]), this.cacheStorage.setItem(_.msalError, o[_.error]), this.cacheStorage.setItem(_.msalErrorDescription, o[_.errorDescription]), t.requestType === _.login && (this.loginInProgress = !1, this.cacheStorage.setItem(_.loginError, o[_.errorDescription] + ":" + o[_.error]), i = Ee.generateAuthorityKey(t.state)), t.requestType === _.renewToken) {
          this.acquireTokenInProgress = !1, i = Ee.generateAuthorityKey(t.state);
          var c = this.getAccount(),
              u = void 0;
          u = c && !J.isEmpty(c.homeAccountIdentifier) ? c.homeAccountIdentifier : _.no_account, a = Ee.generateAcquireTokenAccountKey(u, t.state);
        }

        var l = o[_.error],
            d = o[_.errorDescription];
        n = Ke.isInteractionRequiredError(l) || Ke.isInteractionRequiredError(d) ? new Ke(o[_.error], o[_.errorDescription]) : new He(o[_.error], o[_.errorDescription]);
      } else if (t.stateMatch) {
        this.logger.info("State is right"), o.hasOwnProperty(_.sessionState) && this.cacheStorage.setItem(_.msalSessionState, o[_.sessionState]), r.accountState = this.getAccountState(t.state);
        var p = "";

        if (o.hasOwnProperty(_.accessToken)) {
          this.logger.info("Fragment has access token"), this.acquireTokenInProgress = !1, o.hasOwnProperty(_.idToken) ? (s = new Ie(o[_.idToken]), r.idToken = s, r.idTokenClaims = s.claims) : (s = new Ie(this.cacheStorage.getItem(_.idTokenKey)), r = J.setResponseIdToken(r, s));
          var h = Ee.generateAuthorityKey(t.state),
              f = this.cacheStorage.getItem(h, this.inCookie);
          if (J.isEmpty(f) || (f = J.replaceTenantPath(f, r.tenantId)), !o.hasOwnProperty(_.clientInfo)) throw this.logger.warning("ClientInfo not received in the response from AAD"), be.createClientInfoNotPopulatedError("ClientInfo not received in the response from the server");
          p = o[_.clientInfo], r.account = Pe.createAccount(s, new ke(p));
          var g = void 0;
          g = r.account && !J.isEmpty(r.account.homeAccountIdentifier) ? r.account.homeAccountIdentifier : _.no_account, a = Ee.generateAcquireTokenAccountKey(g, t.state);
          var m = Ee.generateAcquireTokenAccountKey(_.no_account, t.state),
              y = this.cacheStorage.getItem(a),
              w = void 0;
          J.isEmpty(y) ? J.isEmpty(this.cacheStorage.getItem(m)) || (r = this.saveAccessToken(r, f, o, p, s)) : (w = JSON.parse(y), r.account && w && J.compareAccounts(r.account, w) ? (r = this.saveAccessToken(r, f, o, p, s), this.logger.info("The user object received in the response is the same as the one passed in the acquireToken request")) : this.logger.warning("The account object created from the response is not the same as the one passed in the acquireToken request"));
        }

        if (o.hasOwnProperty(_.idToken)) {
          this.logger.info("Fragment has id token"), this.loginInProgress = !1, s = new Ie(o[_.idToken]), r = J.setResponseIdToken(r, s), o.hasOwnProperty(_.clientInfo) ? p = o[_.clientInfo] : this.logger.warning("ClientInfo not received in the response from AAD"), i = Ee.generateAuthorityKey(t.state);
          f = this.cacheStorage.getItem(i, this.inCookie);
          J.isEmpty(f) || (f = J.replaceTenantPath(f, s.tenantId)), this.account = Pe.createAccount(s, new ke(p)), r.account = this.account, s && s.nonce ? s.nonce !== this.cacheStorage.getItem(_.nonceIdToken, this.inCookie) ? (this.account = null, this.cacheStorage.setItem(_.loginError, "Nonce Mismatch. Expected Nonce: " + this.cacheStorage.getItem(_.nonceIdToken, this.inCookie) + ",Actual Nonce: " + s.nonce), this.logger.error("Nonce Mismatch.Expected Nonce: " + this.cacheStorage.getItem(_.nonceIdToken, this.inCookie) + ",Actual Nonce: " + s.nonce), n = be.createNonceMismatchError(this.cacheStorage.getItem(_.nonceIdToken, this.inCookie), s.nonce)) : (this.cacheStorage.setItem(_.idTokenKey, o[_.idToken]), this.cacheStorage.setItem(_.msalClientInfo, p), this.saveAccessToken(r, f, o, p, s)) : (i = t.state, a = t.state, this.logger.error("Invalid id_token received in the response"), n = be.createInvalidIdTokenError(s), this.cacheStorage.setItem(_.msalError, n.errorCode), this.cacheStorage.setItem(_.msalErrorDescription, n.errorMessage));
        }
      } else {
        i = t.state, a = t.state;
        var v = this.cacheStorage.getItem(_.stateLogin, this.inCookie);
        this.logger.error("State Mismatch.Expected State: " + v + ",Actual State: " + t.state), n = be.createInvalidStateError(t.state, v), this.cacheStorage.setItem(_.msalError, n.errorCode), this.cacheStorage.setItem(_.msalErrorDescription, n.errorMessage);
      }

      if (this.cacheStorage.setItem(_.renewStatus + t.state, _.tokenRenewStatusCompleted), this.cacheStorage.removeAcquireTokenEntries(t.state), this.inCookie && (this.cacheStorage.setItemCookie(i, "", -1), this.cacheStorage.clearCookie()), n) throw n;
      if (!r) throw Z.createUnexpectedError("Response is null");
      return r;
    }, e.prototype.getAccount = function () {
      if (this.account) return this.account;
      var e = this.cacheStorage.getItem(_.idTokenKey),
          t = this.cacheStorage.getItem(_.msalClientInfo);

      if (!J.isEmpty(e) && !J.isEmpty(t)) {
        var n = new Ie(e),
            r = new ke(t);
        return this.account = Pe.createAccount(n, r), this.account;
      }

      return null;
    }, e.prototype.getAccountState = function (e) {
      if (e) {
        var t = e.indexOf("|");
        if (t > -1 && t + 1 < e.length) return e.substring(t + 1);
      }

      return e;
    }, e.prototype.getAllAccounts = function () {
      for (var e = [], t = this.cacheStorage.getAllAccessTokens(_.clientId, _.homeAccountIdentifier), n = 0; n < t.length; n++) {
        var r = new Ie(t[n].value.idToken),
            o = new ke(t[n].value.homeAccountIdentifier),
            i = Pe.createAccount(r, o);
        e.push(i);
      }

      return this.getUniqueAccounts(e);
    }, e.prototype.getUniqueAccounts = function (e) {
      if (!e || e.length <= 1) return e;

      for (var t = [], n = [], r = 0; r < e.length; ++r) {
        e[r].homeAccountIdentifier && -1 === t.indexOf(e[r].homeAccountIdentifier) && (t.push(e[r].homeAccountIdentifier), n.push(e[r]));
      }

      return n;
    }, e.prototype.validateInputScope = function (e, t) {
      if (e) {
        if (!Array.isArray(e)) throw Ce.createScopesNonArrayError(e);
        if (e.length < 1) throw Ce.createEmptyScopesArrayError(e.toString());
        if (e.indexOf(this.clientId) > -1 && e.length > 1) throw Ce.createClientIdSingleScopeError(e.toString());
      } else if (t) throw Ce.createScopesRequiredError(e);
    }, e.prototype.getScopeFromState = function (e) {
      if (e) {
        var t = e.indexOf("|");
        if (t > -1 && t + 1 < e.length) return e.substring(t + 1);
      }

      return "";
    }, e.prototype.appendScopes = function (e) {
      var t;
      return e && e.scopes && (t = e.extraScopesToConsent ? e.scopes.concat(e.extraScopesToConsent) : e.scopes), t;
    }, e.prototype.broadcast = function (e, t) {
      var n = new CustomEvent(e, {
        detail: t
      });
      window.dispatchEvent(n);
    }, e.prototype.getCachedTokenInternal = function (e, t, n) {
      var r = t || this.getAccount();
      if (!r) return null;
      var o = this.authorityInstance ? this.authorityInstance : _e.CreateInstance(this.authority, this.config.auth.validateAuthority),
          i = this.getTokenType(r, e, !0),
          a = new Y(o, this.clientId, e, i, this.getRedirectUri(), n);
      return this.getCachedToken(a, t);
    }, e.prototype.getScopesForEndpoint = function (e) {
      if (this.config.framework.unprotectedResources.length > 0) for (var t = 0; t < this.config.framework.unprotectedResources.length; t++) {
        if (e.indexOf(this.config.framework.unprotectedResources[t]) > -1) return null;
      }
      if (this.config.framework.protectedResourceMap.size > 0) for (var n = 0, r = Array.from(this.config.framework.protectedResourceMap.keys()); n < r.length; n++) {
        var o = r[n];
        if (e.indexOf(o) > -1) return this.config.framework.protectedResourceMap.get(o);
      }
      return e.indexOf("http://") > -1 || e.indexOf("https://") > -1 ? this.getHostFromUri(e) === this.getHostFromUri(this.getRedirectUri()) ? new Array(this.clientId) : null : new Array(this.clientId);
    }, e.prototype.getLoginInProgress = function () {
      return !!this.cacheStorage.getItem(_.urlHash) || this.loginInProgress;
    }, e.prototype.setloginInProgress = function (e) {
      this.loginInProgress = e;
    }, e.prototype.getAcquireTokenInProgress = function () {
      return this.acquireTokenInProgress;
    }, e.prototype.setAcquireTokenInProgress = function (e) {
      this.acquireTokenInProgress = e;
    }, e.prototype.getLogger = function () {
      return this.config.system.logger;
    }, e.prototype.getRedirectUri = function () {
      return "function" == typeof this.config.auth.redirectUri ? this.config.auth.redirectUri() : this.config.auth.redirectUri;
    }, e.prototype.getPostLogoutRedirectUri = function () {
      return "function" == typeof this.config.auth.postLogoutRedirectUri ? this.config.auth.postLogoutRedirectUri() : this.config.auth.postLogoutRedirectUri;
    }, e.prototype.getCurrentConfiguration = function () {
      if (!this.config) throw Ce.createNoSetConfigurationError();
      return this.config;
    }, e.prototype.getHostFromUri = function (e) {
      var t = String(e).replace(/^(https?:)\/\//, "");
      return t = t.split("/")[0];
    }, e.prototype.getTokenType = function (e, t, n) {
      return n ? J.compareAccounts(e, this.getAccount()) ? t.indexOf(this.config.auth.clientId) > -1 ? tt : nt : t.indexOf(this.config.auth.clientId) > -1 ? tt : rt : J.compareAccounts(e, this.getAccount()) ? t.indexOf(this.clientId) > -1 ? tt : nt : rt;
    }, e.prototype.setAccountCache = function (e, t) {
      var n = e ? this.getAccountId(e) : _.no_account,
          r = Ee.generateAcquireTokenAccountKey(n, t);
      this.cacheStorage.setItem(r, JSON.stringify(e));
    }, e.prototype.setAuthorityCache = function (e, t) {
      var n = Ee.generateAuthorityKey(e);
      this.cacheStorage.setItem(n, J.CanonicalizeUri(t), this.inCookie);
    }, e.prototype.updateCacheEntries = function (e, t, n) {
      n ? (this.cacheStorage.setItem(_.loginRequest, n, this.inCookie), this.cacheStorage.setItem(_.loginError, ""), this.cacheStorage.setItem(_.stateLogin, e.state, this.inCookie), this.cacheStorage.setItem(_.msalError, ""), this.cacheStorage.setItem(_.msalErrorDescription, "")) : this.setAccountCache(t, e.state), this.setAuthorityCache(e.state, e.authority), this.cacheStorage.setItem(_.nonceIdToken, e.nonce, this.inCookie);
    }, e.prototype.getAccountId = function (e) {
      return J.isEmpty(e.homeAccountIdentifier) ? _.no_account : e.homeAccountIdentifier;
    }, e.prototype.buildIDTokenRequest = function (e) {
      return {
        scopes: [this.clientId],
        authority: this.authority,
        account: this.getAccount(),
        extraQueryParameters: e.extraQueryParameters
      };
    }, e.prototype.populateQueryParams = function (e, t, n, r) {
      var o,
          i = {};
      return t && (t.prompt && (this.validatePromptParameter(t.prompt), n.promptValue = t.prompt), t.claimsRequest && (!function (e) {
        if (e.claimsRequest) try {
          JSON.parse(e.claimsRequest);
        } catch (e) {
          throw Ce.createClaimsRequestParsingError(e);
        }
      }(t), n.claimsValue = t.claimsRequest), J.isSSOParam(t) && (i = J.constructUnifiedCacheQueryParameter(t, null))), r && (i = J.constructUnifiedCacheQueryParameter(null, r)), this.logger.verbose("Calling addHint parameters"), i = this.addHintParameters(e, i, n), t && (o = this.sanitizeEQParams(t)), n.queryParameters = J.generateQueryParametersString(i), n.extraQueryParameters = J.generateQueryParametersString(o), n;
    }, e.prototype.validatePromptParameter = function (e) {
      if (!([G.LOGIN, G.SELECT_ACCOUNT, G.CONSENT, G.NONE].indexOf(e) >= 0)) throw Ce.createInvalidPromptError(e);
    }, e.prototype.sanitizeEQParams = function (e) {
      var t = this,
          n = e.extraQueryParameters;
      return n ? (e.claimsRequest && (this.logger.warning("Removed duplicate claims from extraQueryParameters. Please use either the claimsRequest field OR pass as extraQueryParameter - not both."), delete n[_.claims]), z.forEach(function (e) {
        n[e] && (t.logger.warning("Removed duplicate " + e + " from extraQueryParameters. Please use the " + e + " field in request object."), delete n[e]);
      }), n) : null;
    }, e.prototype.getTelemetryManagerFromConfig = function (e, t) {
      if (!e) return null;
      var n = e.applicationName,
          r = e.applicationVersion,
          o = e.telemetryEmitter;
      if (!n || !r || !o) throw Ce.createTelemetryConfigError(e);
      var i = {
        sdk: "msal.js",
        sdkVersion: J.getLibraryVersion(),
        applicationName: n,
        applicationVersion: r
      };
      return new Ze({
        platform: i,
        clientId: t
      }, o);
    }, function (e, t, n, r) {
      var o,
          i = arguments.length,
          a = i < 3 ? t : null === r ? r = Object.getOwnPropertyDescriptor(t, n) : r;
      if ("object" == typeof Reflect && "function" == typeof Reflect.decorate) a = Reflect.decorate(e, t, n, r);else for (var s = e.length - 1; s >= 0; s--) {
        (o = e[s]) && (a = (i < 3 ? o(a) : i > 3 ? o(t, n, a) : o(t, n)) || a);
      }
      i > 3 && a && Object.defineProperty(t, n, a);
    }([ot], e.prototype, "acquireTokenSilent", null), e;
  }(),
      at = function at() {
    var e = window.navigator.userAgent,
        t = e.indexOf("MSIE ") > -1,
        n = e.indexOf("Trident/") > -1,
        r = e.indexOf("Edge/") > -1;
    return t || n || r;
  },
      st = function st(e) {
    return !(!e || !e.length) && (e.indexOf("consent_required") > -1 || e.indexOf("interaction_required") > -1 || e.indexOf("login_required") > -1);
  },
      ct = function ct(e) {
    if (!(e = sessionStorage.getItem(e))) return 0;
    var t = new Date(1e3 * JSON.parse(window.atob(e.split(".")[1])).exp),
        n = new Date();
    return (t.getTime() - n.getTime()) / 1e3;
  },
      ut = function ut(e) {
    var t = ct(e),
        n = Math.max(Math.floor(t / 60), 0);
    return [n, Math.trunc(t - 60 * n)];
  },
      lt = function (e) {
    function n(e) {
      var t;
      return function (e, t) {
        if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
      }(this, n), t = function (e, t) {
        return !t || "object" != typeof t && "function" != typeof t ? f(e) : t;
      }(this, p(n).call(this, e)), c(f(t), "handleLogin", a(_regeneratorRuntime.mark(function e() {
        var n, r, o;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                if (n = t.props, r = n.scopes, o = n.onAuthError, t.setState({
                  error: null
                }), !at()) {
                  e.next = 4;
                  break;
                }

                return e.abrupt("return", t.msalInstance.loginRedirect({
                  scopes: r
                }));

              case 4:
                return e.next = 6, t.msalInstance.loginPopup({
                  scopes: r
                }).catch(function (e) {
                  t.setState({
                    loading: !1,
                    error: o(e),
                    expiryWarningVisible: !1
                  });
                });

              case 6:
                e.sent && t.getApplicationTokens();

              case 8:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }))), c(f(t), "getApplicationTokens", a(_regeneratorRuntime.mark(function e() {
        var n, o, i, a, s, c, u, l, d;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = t.props.onAuthSuccess, o = t.state.expiryWarningVisible, t.setState({
                  loading: !0
                }), e.next = 5, t.getAzureToken();

              case 5:
                return i = e.sent, a = i.idToken, s = i.accessToken, e.next = 9, n(a.rawIdToken, s);

              case 9:
                c = e.sent, u = c.accessToken, l = c.refreshToken, d = c.extras, l ? (sessionStorage.setItem("refresh", l), sessionStorage.setItem("access", u), t.checkRefreshTokenExpiry()) : u && (sessionStorage.setItem("access", u), t.checkAccessTokenExpiry()), o && r.notification.success({
                  message: "Your session has been extended"
                }), t.setState({
                  loading: !1,
                  authenticated: !0,
                  extras: d,
                  expiryWarningVisible: !1
                });

              case 14:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }))), c(f(t), "handleLogout", function () {
        sessionStorage.clear(), t.msalInstance.logout();
      }), c(f(t), "handleTokenExpiry", function () {
        sessionStorage.clear(), clearInterval(t.expiryCountdown), clearInterval(t.tokenExpiry), t.setState({
          authenticated: !1
        });
      }), c(f(t), "throwTokenError", function () {
        t.handleTokenExpiry(), t.state.expiryWarningVisible || (t.setState({
          expiryWarningVisible: !0
        }), r.Modal.confirm({
          icon: "warning",
          title: "Your session has expired",
          content: "Please log in again to continue.",
          cancelButtonProps: {
            style: {
              display: "none"
            }
          },
          onOk: function onOk() {
            return t.setState({
              expiryWarningVisible: !1
            });
          }
        }));
      }), c(f(t), "getAzureToken", a(_regeneratorRuntime.mark(function e() {
        var n;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = t.props.scopes, e.abrupt("return", t.msalInstance.acquireTokenSilent({
                  scopes: n
                }).catch(function (e) {
                  if (st(e.errorCode)) return at() ? t.msalInstance.acquireTokenRedirect({
                    scopes: n
                  }) : t.msalInstance.acquireTokenPopup({
                    scopes: n
                  });
                }));

              case 2:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }))), c(f(t), "refreshAccessToken", a(_regeneratorRuntime.mark(function e() {
        var n, r;
        return _regeneratorRuntime.wrap(function (e) {
          for (;;) {
            switch (e.prev = e.next) {
              case 0:
                return n = t.props.refreshAccess, e.next = 3, n(sessionStorage.getItem("refresh")).catch(function () {
                  t.throwTokenError();
                });

              case 3:
                return r = e.sent, sessionStorage.setItem("access", r), e.abrupt("return", r);

              case 6:
              case "end":
                return e.stop();
            }
          }
        }, e);
      }))), c(f(t), "checkRefreshTokenExpiry", function () {
        var e = t.props,
            n = e.refreshAccess,
            o = e.tokenCheckFrequency;
        if (!n) throw new Error("If refresh tokens are being used, then a function must be provided to perform token refreshes");
        t.tokenExpiry = setInterval(function () {
          ct("access") < 300 && t.refreshAccessToken();
          var e = ct("refresh");

          if (e > 0 && e < 300 && !t.state.expiryWarningVisible) {
            var n = g(ut("refresh"), 2),
                o = n[0],
                i = n[1];
            t.setState({
              expiryWarningVisible: !0
            });
            var a = r.Modal.confirm({
              title: "Timeout warning",
              icon: "warning",
              content: "You will be logged out in ".concat(o, " minutes\n              and ").concat(i, " seconds. Press OK to extend your session."),
              onOk: function onOk() {
                t.handleLogin();
              },
              onCancel: function onCancel() {
                t.setState({
                  expiryWarningVisible: !1
                }), clearInterval(t.expiryCountdown);
              }
            });
            t.expiryCountdown = setInterval(function () {
              var e = g(ut("refresh"), 2);
              o = e[0], i = e[1], 0 === o && i <= 0 ? (t.handleTokenExpiry(), a.update({
                title: "Your session has expired",
                content: "Please log in again to continue.",
                cancelButtonProps: {
                  style: {
                    display: "none"
                  }
                }
              })) : a.update({
                content: "You will be logged out in ".concat(o, " minutes\n                  and ").concat(i, " seconds. Press OK to extend your session.")
              });
            }, 1e3);
          } else e <= 0 && !t.state.expiryWarningVisible && t.throwTokenError();
        }, 60 * o * 1e3);
      }), c(f(t), "checkAccessTokenExpiry", function () {
        var e = t.props.tokenCheckFrequency;
        t.tokenExpiry = setInterval(function () {
          var e = ct("access");

          if (e > 0 && e < 300 && !t.state.expiryWarningVisible) {
            var n = g(ut("access"), 2),
                o = n[0],
                i = n[1];
            t.setState({
              expiryWarningVisible: !0
            });
            var a = r.Modal.confirm({
              title: "Your session will expire soon",
              icon: "warning",
              content: "You will be logged out in ".concat(o, " minutes\n              and ").concat(i, " seconds."),
              cancelButtonProps: {
                style: {
                  display: "none"
                }
              },
              onOk: function onOk() {
                t.setState({
                  expiryWarningVisible: !1
                }), clearInterval(t.expiryCountdown);
              }
            });
            t.expiryCountdown = setInterval(function () {
              var e = g(ut("access"), 2);
              o = e[0], i = e[1], 0 === o && i <= 0 ? (t.handleTokenExpiry(), a.update({
                title: "Your session has expired",
                content: "Please log in again to continue."
              })) : a.update({
                content: "You will be logged out in ".concat(o, " minutes\n                  and ").concat(i, " seconds.")
              });
            }, 1e3);
          } else e <= 0 && !t.state.expiryWarningVisible && t.throwTokenError();
        }, 60 * e * 1e3);
      }), t.msalInstance = new it({
        cache: {
          cacheLocation: "sessionStorage",
          storeAuthStateInCookie: at()
        },
        auth: d({}, e.msalConfig.auth, {
          navigateToLoginRequestUrl: !1,
          validateAuthority: !0
        })
      }), t.state = {}, t;
    }

    var i, l, m;
    return function (e, t) {
      if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
      e.prototype = Object.create(t && t.prototype, {
        constructor: {
          value: e,
          writable: !0,
          configurable: !0
        }
      }), t && h(e, t);
    }(n, t.Component), i = n, (l = [{
      key: "componentDidMount",
      value: function value() {
        var e = this.props.onAuthError,
            t = ct("access") > 0,
            n = ct("refresh") > 0;
        t && n ? this.checkRefreshTokenExpiry() : n ? (this.refreshAccessToken(), this.checkRefreshTokenExpiry()) : t && this.checkAccessTokenExpiry(), this.msalInstance.handleRedirectCallback(function (t) {
          t && e(t);
        }), !this.msalInstance.getAccount() || t || n || this.getApplicationTokens(), this.setState({
          authenticated: t || n
        });
      }
    }, {
      key: "render",
      value: function value() {
        var e = this.props,
            t = e.WrappedComponent,
            n = e.landingPage,
            r = this.state,
            i = r.authenticated,
            a = r.loading,
            s = r.error,
            c = r.extras;
        return i ? o.createElement(t, u({
          getAzureToken: this.getAzureToken,
          isTokenExpired: function isTokenExpired() {
            return {
              access: ct("access") > 0,
              refresh: ct("refresh") > 0
            };
          },
          refreshAccessToken: this.refreshAccessToken,
          throwTokenError: this.throwTokenError,
          logout: this.handleLogout
        }, c)) : o.cloneElement(n, {
          handleLogin: this.handleLogin,
          loading: a,
          error: s
        });
      }
    }]) && s(i.prototype, l), m && s(i, m), n;
  }();

  c(lt, "propTypes", {
    WrappedComponent: P.any.isRequired,
    landingPage: P.any.isRequired,
    msalConfig: P.shape({
      auth: P.shape({
        clientId: P.string.isRequired
      }),
      cache: P.object,
      system: P.object
    }).isRequired,
    scopes: P.arrayOf(P.string),
    onAuthSuccess: P.func.isRequired,
    onAuthError: P.func.isRequired,
    refreshAccess: P.func,
    tokenCheckFrequency: P.number
  }), c(lt, "defaultProps", {
    scopes: ["user.read"],
    tokenCheckFrequency: 2.5
  });

  e.authenticatedApplication = function (e) {
    return function (t) {
      return function () {
        return o.createElement(lt, u({}, e, {
          WrappedComponent: t
        }));
      };
    };
  };
});